window.addEventListener('pageshow', function(e) {
  if (e.persisted) {
    var sc = document.querySelector('.side-cart');
    if (sc) sc.classList.remove('open');
    document.body.classList.remove('body-no-scroll');
    var msg = document.querySelector('.sc-upsell-msg');
    if (msg) msg.style.display = 'none';
    var prog = document.querySelector('.progress-with-message');
    if (prog) prog.style.display = 'none';

    // Reset checkout button if customer hit Back from checkout (bfcache).
    // Without this, the button stays in its loading state and is uninteractive.
    var checkoutWrap = document.querySelector('.sc-proceed-to-checkout');
    if (checkoutWrap) {
      checkoutWrap.classList.remove('is-loading');
      var checkoutLink = checkoutWrap.querySelector('a');
      if (checkoutLink && checkoutLink.dataset.originalText) {
        checkoutLink.textContent = checkoutLink.dataset.originalText;
      }
    }
  }
});

// Tracks the last product_id used to seed suggestion data — read by
// fetchJacketProductHtml to skip jacket suggestions when source is itself a jacket.
var _lastTriggerProductId;

document.addEventListener("DOMContentLoaded", function () {

  
    // Function to check if the gift item is visible
    function isGiftVisible() {
      return document.querySelector(".variants_gift_c").style.display === "block";
    }
    
    // Function to get the selected variant ID from the radio button
    function getSelectedVariantId() {
      const selectedRadio = document.querySelector('.variants_gift_c input[name="product-variant"]:checked');
      if (selectedRadio) {
        return selectedRadio.getAttribute('data-var-id');
      }
      return null; // Return null if no variant is selected
    }
    function addGiftToCart() {
      // if (!isGiftVisible()) {
        // Get the selected variant ID
      
        
        var selectedVariantId = getSelectedVariantId();
      
     
        if (!selectedVariantId) {
          console.log("No variant selected");
          return;
        }
    
      // console.log('addGiftToCart inside');
    
        // Prepare the data for adding the gift to the cart
     
        var data = {
          items: [
            {
              id: selectedVariantId,  // Use the selected variant ID
              quantity: 1             // Quantity to add to the cart
            }
          ]
        };
    
        // Use Shopify's AJAX API to add the gift to the cart
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        })
        .then(response => response.json())
        .then(cart => {
          console.log('Gift added to cart:', cart);
          window.location.href = "/checkout";
        })
        .catch(error => {
          console.error('Error adding gift to cart:', error);
        });
      // }
    }
    


    document.addEventListener("click", function(event) {
      var checkoutWrap = event.target.closest('.sc-proceed-to-checkout');
      if(checkoutWrap){
        event.preventDefault();

        // Guard: if a checkout is already in flight, ignore further taps.
        // Combined with pointer-events:none on .is-loading this stops
        // double-tap stuck-checkout scenarios on slow phones.
        if (checkoutWrap.classList.contains('is-loading')) return;

        // Immediately swap the button into a loading state so the customer
        // gets feedback during the remapFlagsBeforeCheckout() async work
        // and the subsequent /checkout redirect.
        var checkoutLink = checkoutWrap.querySelector('a');
        if (checkoutLink) {
          if (!checkoutLink.dataset.originalText) {
            checkoutLink.dataset.originalText = checkoutLink.textContent.trim();
          }
          checkoutLink.innerHTML =
            '<span class="sc-checkout-spinner" aria-hidden="true"></span>' +
            '<span class="sc-checkout-loading-text">Preparing your cart…</span>';
        }
        checkoutWrap.classList.add('is-loading');

        remapFlagsBeforeCheckout().then(function() {
        let giftDiv = document.querySelector('.upsell_free_gift');
        if(giftDiv){
          let prdouctId = parseInt(giftDiv.dataset.id);
          fetch('/cart.js')
          .then(res=> res.json())
          .then(cart=>{
            let items = cart.items;
    
            // Convert subtotal price to a decimal
            let discountedSubTotalStr = cart.items_subtotal_price.toString();
            let discountedSubTotalPrice = parseFloat(
              discountedSubTotalStr.slice(0, -2) +
                "." +
                discountedSubTotalStr.slice(-2)
            );
    
            // Subtotal minus 100 calculation
            let discountThreshold = document.querySelector('div.discount__price');
            let thresholdNum = parseInt(discountThreshold.dataset.discount);
            let discountedGiftPrice = (discountedSubTotalPrice - thresholdNum).toFixed(2);
        
            var handleGiftCard = discountThreshold.getAttribute('data-handle');
            var giftCardExistsInCart = cart.items.some(item => item.handle === handleGiftCard);
            console.log("discountedSubTotalStr",discountedSubTotalStr);
            console.log("discountThreshold",thresholdNum);

            if (discountedSubTotalPrice >= thresholdNum && !giftCardExistsInCart) {
              // console.log('eeee')
              addGiftToCart();
            }
            else{
              // console.log('sss')
              window.location.href = "/checkout";
            }
          })
        }
        else{
           window.location.href = "/checkout";
        }
        }); // end remapFlagsBeforeCheckout
      }
    });

    // ── Jacket suggestion: detail popup open/close ──
    // Delegated so it survives every cart rebuild (suggestions HTML is
    // regenerated on every cart action).
    document.addEventListener("click", function(event) {
      var trigger = event.target.closest('.suggest-item.jacket .jacket-new-badge');
      if (trigger) {
        event.preventDefault();
        event.stopPropagation();
        var tile = trigger.closest('.suggest-item.jacket');
        if (tile) tile.classList.add('popup-open');

        // Analytics — fires to whichever setup is present (GA4 via
        // dataLayer/GTM and/or direct gtag.js). Wrapped in try/catch so a
        // missing/blocked analytics layer can never break the UX.
        try {
          var payload = {
            event_category: 'engagement',
            event_label: 'side_cart_jacket_info_button',
            location: 'side_cart_suggestion',
            product_handle: 'custom-numbered-varsity-jacket'
          };
          if (window.dataLayer && typeof window.dataLayer.push === 'function') {
            window.dataLayer.push(Object.assign({ event: 'jacket_info_click' }, payload));
          }
          if (typeof window.gtag === 'function') {
            window.gtag('event', 'jacket_info_click', payload);
          }
        } catch (e) { /* swallow — analytics must never break UX */ }

        return;
      }
      var closeBtn = event.target.closest('.suggest-item.jacket .jacket-detail-popup-close');
      if (closeBtn) {
        event.preventDefault();
        event.stopPropagation();
        var tile = closeBtn.closest('.suggest-item.jacket');
        if (tile) tile.classList.remove('popup-open');
        return;
      }

      // Analytics: side-cart jacket Add to Cart click. Fires on tap of the
      // ADD TO CART button inside the jacket suggestion tile only — no other
      // adds anywhere else are tracked. Purely additive listener; does not
      // call preventDefault or stopPropagation, so the existing
      // addSuggestedItemToCart(event) onclick handler still runs normally.
      var jacketAddBtn = event.target.closest('.suggest-item.jacket .sc-add-to-cart a');
      if (jacketAddBtn) {
        try {
          var variantId = jacketAddBtn.getAttribute('data-variantid');
          var payload = {
            event_category: 'ecommerce',
            event_label: 'side_cart_jacket_add_to_cart',
            location: 'side_cart_suggestion',
            product_handle: 'custom-numbered-varsity-jacket',
            variant_id: variantId
          };
          if (window.dataLayer && typeof window.dataLayer.push === 'function') {
            window.dataLayer.push(Object.assign({ event: 'jacket_added_to_cart' }, payload));
          }
          if (typeof window.gtag === 'function') {
            window.gtag('event', 'jacket_added_to_cart', payload);
          }
        } catch (e) { /* swallow — analytics must never break UX */ }
      }
    });
      
      var cartIcon = document.querySelector(".site-header__cart");
      var sideCart = document.querySelector(".side-cart");
      var closeSideCart = document.querySelector(".sc-icon-close");
      var checkout = document.querySelector(".sc-proceed-to-checkout a");
      var continueShopping = document.querySelector(".continue_shopping_btn .continue_sh");
      var cartProgress = sideCart.querySelector(".progress-with-message");
      var headerMEssage = document.querySelector(".cart_message .progress-with-message");
    
      // checkout.addEventListener("click", function () {
      //   window.location.href = "/checkout";
      // });
    
      cartIcon.href = "javascript:void(0)";
      updateCartDrawer();
    
      cartIcon.addEventListener("click", function () {
        event.stopPropagation();
        sideCart.classList.add("open");
        updateCartDrawer();
        var bodyClass = document.body.className;
        if (bodyClass.indexOf("body-no-scroll") === -1) {
          document.body.className += " body-no-scroll";
        }
      });
    
      closeSideCart.addEventListener("click", function () {
        var bodyClass = document.body.className;
        sideCart.classList.remove("open");
        cartProgress.style.display = "none";
        if (headerMEssage) headerMEssage.style.display = "block";
        document.body.className = bodyClass.replace(" body-no-scroll", "");
      });
    
      document.addEventListener("click", function (event) {
        var sideCart = document.querySelector(".side-cart");
        var isClickInside = sideCart.contains(event.target);
        var bodyClass = document.body.className;
    
        if (!isClickInside) {
          sideCart.classList.remove("open");
          cartProgress.style.display = "none";
          if (headerMEssage) headerMEssage.style.display = "block";
          document.body.className = bodyClass.replace(" body-no-scroll", "");
        }
      });
    
      if (continueShopping) {
        continueShopping.addEventListener("click", function () {
          var bodyClass = document.body.className;
          sideCart.classList.remove("open");
          cartProgress.style.display = "none";
          if (headerMEssage) headerMEssage.style.display = "block";
          document.body.className = bodyClass.replace(" body-no-scroll", "");
        });
      }
      var productForm = document.querySelector("form.product-form");
      if (productForm) {
        productForm.addEventListener("submit", function (e) {
          e.preventDefault();

          // ── ATC button: hot pink + "Added to Cart" on click ──
          var atcBtn = productForm.querySelector('.product-form__cart-submit');
          if (atcBtn) {
            atcBtn.classList.add('cn-added');
            atcBtn.setAttribute('data-original-text', atcBtn.textContent.trim());
            atcBtn.textContent = 'Added to Cart ✓';
          }

          var formData = new FormData(productForm);
    
          fetch("/cart/add.js", {
            method: "POST",
            body: formData,
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              Accept: "application/json",
            },
          })
            .then((response) => {
              if (!response.ok) {
                throw new Error("Network response was not ok");
              }
              return response.json();
            })
            .then((data) => {
              console.log("Product added to cart:", data);
              // Exactly-once continuation: the pair popup (cn-pair-popup.js)
              // may defer the side-cart open, but every popup exit — and its
              // 800ms decision timeout — funnels back here. The _done guard
              // makes a late duplicate call a no-op.
              var openSideCartNow = function () {
                if (openSideCartNow._done) return;
                openSideCartNow._done = true;
                updateCartDrawer();
                sideCart.classList.add("open");
                // ── Reset button immediately when side cart opens ──
                if (atcBtn) {
                  atcBtn.classList.remove('cn-added');
                  atcBtn.textContent = atcBtn.getAttribute('data-original-text') || 'Add to Cart';
                }
                var bodyClass = document.body.className;
                if (bodyClass.indexOf("body-no-scroll") === -1) {
                  document.body.className += " body-no-scroll";
                }
              };
              // Fail open: popup script missing or throwing → straight to cart.
              try {
                if (window.CNPairPopup && typeof window.CNPairPopup.maybeShow === 'function') {
                  window.CNPairPopup.maybeShow(data, openSideCartNow);
                } else {
                  openSideCartNow();
                }
              } catch (e) {
                openSideCartNow();
              }
            })
            .catch((error) => {
              console.error("Error adding product to cart:", error);
              // Reset button on error too
              if (atcBtn) {
                atcBtn.classList.remove('cn-added');
                atcBtn.textContent = atcBtn.getAttribute('data-original-text') || 'Add to Cart';
              }
            });
        });
      }
    });
    
    function updateCartDrawer(suggestRemaining = null) {
      var sideCart = document.querySelector(".side-cart");
      var cartItems = document.querySelector(".side-cart .sc-items");
      var CartCount = document.getElementById("CartCount");
      var dataCartCount = CartCount.querySelector("span[data-cart-count]");
      var subTotal = document.getElementById("sc-subtotal");
      // var discountGift = document.getElementById("discount-price");
      var shippingTotal = document.getElementById("sc-shipping");
      var ajaxLoader = sideCart.querySelector(".sc-loading");
      var sideCartInner = sideCart.querySelector(".side-cart-inner");
      var suggestions = sideCart.querySelector(".suggestions");
      var upsells = sideCart.querySelector(".sc-upsells");
      var cartTotal = sideCart.querySelector(".sc-cart-total");
      var toCheckout = sideCart.querySelector(".sc-proceed-to-checkout");
      var cartContent = sideCart.querySelector(".sc-content");
      var cartFooter = sideCart.querySelector(".sc-footer");
      var cartTitle = sideCart.querySelector(".sc-title");
      var currency = sideCart.getAttribute("data-currency");
      var cartProgress = sideCart.querySelector(".progress-with-message");
      var headerMEssage = document.querySelector(
        ".cart_message .progress-with-message"
      ) || null;
      upsells.style.display = "block";
      cartFooter.style.display = "block";
    
      fetch("/cart.js", {
        method: "GET",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/json",
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
        // console.log("cart data:", data);

        // ── GUARDIAN: remove free gift + coach addon if real subtotal below threshold ──
        var _guardianGift = document.querySelector('.first__freegift');
        if (_guardianGift) {
          var _gHandle = _guardianGift.getAttribute('data-handle');
          var _gThreshold = parseInt(_guardianGift.getAttribute('data-discount'));
          if (_gHandle && _gThreshold) {
            var _gRealSubtotal = data.items.reduce(function(sum, i) {
              if (i.handle === _gHandle || i.handle === 'decal-sheet-add-on' || i.handle === 'coach-sleeve-add-on') return sum;
              var p = i.line_price.toString();
              return sum + parseFloat(p.slice(0,-2)+'.'+p.slice(-2));
            }, 0);
            var _gInCart = data.items.find(function(i) { return i.handle === _gHandle; });
            var _gAddonInCart = data.items.find(function(i) { return i.handle === 'coach-sleeve-add-on'; });
            if ((_gInCart || _gAddonInCart) && _gRealSubtotal < _gThreshold) {
              var _gUpdates = {};
              if (_gInCart) _gUpdates[_gInCart.key] = 0;
              if (_gAddonInCart) _gUpdates[_gAddonInCart.key] = 0;
              fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ updates: _gUpdates })
              }).then(function(r){ return r.json(); }).then(function() { updateCartDrawer(); });
              return;
            }
          }
        }
        // ── END GUARDIAN ──

        // Convert subtotal price to a decimal — exclude addon products so threshold logic is accurate
        var _thresholdAddonHandles = ['decal-sheet-add-on', 'coach-sleeve-add-on'];
        var _firstFreegiftEl = document.querySelector('.first__freegift');
        if (_firstFreegiftEl) { var _fgHandle = _firstFreegiftEl.getAttribute('data-handle'); if (_fgHandle) _thresholdAddonHandles.push(_fgHandle); }
        let discountedSubTotalPrice = data.items.reduce(function(sum, i) {
          if (_thresholdAddonHandles.indexOf(i.handle) > -1) return sum;
          var p = i.line_price.toString();
          return sum + parseFloat(p.slice(0,-2)+'.'+p.slice(-2));
        }, 0);
    
        // Subtotal minus 100 calculation
        let discountThreshold = document.querySelector('div.discount__price');
        if(discountThreshold){
        let thresholdNum = parseInt(discountThreshold.dataset.discount);
        let discountedGiftPrice = (discountedSubTotalPrice - thresholdNum);
        var handleGiftCard = discountThreshold.getAttribute('data-handle');
        var giftCardExistsInCart = data.items.some(item => item.handle === handleGiftCard);
    
        if(thresholdNum > discountedSubTotalPrice) {
          var _giftToRemove = data.items.find(function(i) { return i.handle === handleGiftCard; });
          var _coachToRemove = data.items.find(function(i) { return i.handle === 'coach-sleeve-add-on'; });
          var _removePromises = [];
          if (_giftToRemove) {
            _removePromises.push(fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: _giftToRemove.key, quantity: 0 })
            }).then(function(r) { return r.json(); }));
          }
          if (_coachToRemove) {
            _removePromises.push(fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: _coachToRemove.key, quantity: 0 })
            }).then(function(r) { return r.json(); }));
          }
          if (_removePromises.length > 0) {
            Promise.all(_removePromises).then(function() { updateCartDrawer(); });
          }
        }
    
        // Ensure the discount div exists
        let discountGift = document.getElementById("discount-price");
        if (!discountGift) {
          discountGift = document.createElement("div");
          discountGift.id = "discount-price";
          discountGift.className = "discount-price"; 
          subTotal.parentNode.appendChild(discountGift);
        }
    
        if(discountedGiftPrice > 0) {
          // Update the content of the discount gift price
          discountGift.innerHTML = `${currency}00.00`;
        }
        else {
          // Update the content of the discount gift price
          discountGift.innerHTML = `${currency}${Math.abs(discountedGiftPrice).toFixed(2)}`;
        }
    
        
    
        // Get the <h4> elements
        const spendMoreMessage = document.querySelector(".discount__price h4:first-child");
        const giftAddedMessage = document.querySelector(".discount__price h4:last-child");
        const image_gift = document.querySelector(".cart-item-image_m");
        var giftItem = document.querySelector(".upsell_free_gift");
        var deleteBtn = document.querySelector(".delete_gift_svg")
          if(giftItem){
            // Toggle visibility based on the value of discountedSubTotalPrice
        if (discountedSubTotalPrice >= thresholdNum) {
          
          // Show "Gift added" message and hide "Spend more" message
          spendMoreMessage.style.display = "none";
          giftAddedMessage.style.display = "block";
          image_gift.style.display="none";
    
          spendMoreMessage.style.display = "none";
          giftAddedMessage.style.display = "block";
          image_gift.style.display="none";
    
          // Always show the variant selector whether gift is pending or already in cart
          giftItem.style.display="block";
          var _coachAddon = document.querySelector('.sc-addon-coach');
          if (_coachAddon) _coachAddon.style.display = 'block';
          
        } else {
          // Show "Spend more" message and hide "Gift added" message
          spendMoreMessage.style.display = "block";
          giftAddedMessage.style.display = "none";
          image_gift.style.display="flex";
          giftItem.style.display="none";
          var _coachAddonHide = document.querySelector('.sc-addon-coach');
          if (_coachAddonHide) _coachAddonHide.style.display = 'none';
        
        }
         }
        }
    
    // // Function to check if the gift item is visible
    // function isGiftVisible() {
    //   return document.querySelector(".variants_gift_c").style.display === "block";
    // }
    
    // // Function to get the selected variant ID from the radio button
    // function getSelectedVariantId() {
    //   const selectedRadio = document.querySelector('.variants_gift_c input[name="product-variant"]:checked');
    //   if (selectedRadio) {
    //     return selectedRadio.getAttribute('data-var-id');
    //   }
    //   return null; // Return null if no variant is selected
    // }
    
    // Add the gift to the cart if it's visible
    
    
    
    
     
          // end of this contant 
          //addingfirstgift

// Get gift DOM element and handle
var messageToDisplayfirst = document.querySelector(".first__gift--before");
var messageToDisplayafter = document.querySelector(".first__gift--after");
var firstmsgupdate=document.querySelector(".first__gift--before #first-discount-price")
var messageToDisplay=document.querySelector(".first__freegift")
var secgiftmsg=document.querySelector(".discount__price");
// First-gift logic must SKIP, not return: this block is inline in the main
// cart render, so an early return here would kill the item/subtotal render
// below whenever .first__freegift is absent (first gift toggled off).
if (messageToDisplay) {

var handlem = messageToDisplay.getAttribute("data-handle");
var datainstock=messageToDisplay.getAttribute("data-instock");
var giftVariantId = messageToDisplay.getAttribute("data-var-id");
var mainholdt = parseInt(messageToDisplay.getAttribute("data-discount"));

// Get cart data
var itemsinside = data.items;
var _addonHandlesThreshold = ['decal-sheet-add-on', 'coach-sleeve-add-on', handlem];
var cartSubtotal = itemsinside.reduce(function(sum, i) {
  if (_addonHandlesThreshold.indexOf(i.handle) > -1) return sum;
  var p = i.line_price.toString();
  return sum + parseFloat(p.slice(0,-2)+'.'+p.slice(-2));
}, 0);

// Check if gift is in cart
var giftInCart = itemsinside.some(item => item.handle === handlem);

console.log("Gift in cart:", giftInCart);
console.log("Cart subtotal:", cartSubtotal, "Threshold:", mainholdt);

// ✅ CASE 1: Add gift if not in cart and subtotal >= threshold

if (!giftInCart && mainholdt > cartSubtotal){
 secgiftmsg.style.display="none";
messageToDisplayfirst.style.display="block";
messageToDisplayafter.style.display="none";
const remainingt = Math.max(0, mainholdt - cartSubtotal);
const remainingRounded = remainingt.toFixed(2);
firstmsgupdate.textContent="$"+remainingRounded
}
else if(giftInCart && cartSubtotal >= mainholdt && datainstock!= "false" ){
   secgiftmsg.style.display="flex";
messageToDisplayfirst.style.display="none";
messageToDisplayafter.style.display="block";
}
if (!giftInCart && cartSubtotal >= mainholdt && datainstock!= "false") {
  const dataToAdd = {
    items: [
      {
        id: giftVariantId,
        quantity: 1
      }
    ]
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(dataToAdd)
  })
    .then(response => response.json())
    .then(cartResponse => {
      console.log('✅ Gift added to cart:', cartResponse);
      updateCartDrawer();
      
      secgiftmsg.style.display="flex";
   
      messageToDisplayfirst.style.display="none";
      messageToDisplayafter.style.display="block";
    })
    .catch(error => {
      console.error('❌ Error adding gift to cart:', error);
    });

// ✅ CASE 2: Remove gift if in cart and subtotal < threshold
} else if (giftInCart && cartSubtotal < mainholdt) {
  var giftLineItem = itemsinside.find(item => item.handle === handlem);
  var coachAddonItem = itemsinside.find(item => item.handle === 'coach-sleeve-add-on');
  var removePromises = [];
  if (giftLineItem) {
    removePromises.push(fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: giftLineItem.key, quantity: 0 })
    }).then(r => r.json()));
  }
  if (coachAddonItem) {
    removePromises.push(fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: coachAddonItem.key, quantity: 0 })
    }).then(r => r.json()));
  }
  if (removePromises.length > 0) {
    Promise.all(removePromises).then(function() {
      console.log('✅ Gift and addon removed from cart');
      secgiftmsg.style.display="none";
      messageToDisplayfirst.style.display="block";
      messageToDisplayafter.style.display="none";
      updateCartDrawer();
    }).catch(error => {
      console.error('❌ Error removing from cart:', error);
    });
  }
}
}  // end if (messageToDisplay) — first-gift block

          // Treat cart as empty if only addon products remain
          var _addonHandles = ['decal-sheet-add-on', 'coach-sleeve-add-on'];
          var _realItems = data.items.filter(function(i) { return _addonHandles.indexOf(i.handle) === -1; });
          var _addonItems = data.items.filter(function(i) { return _addonHandles.indexOf(i.handle) > -1; });

          if (_realItems.length === 0 && _addonItems.length > 0) {
            // Only addons left — silently remove them
            _addonItems.forEach(function(i) {
              fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: i.key, quantity: 0 })
              });
            });
          }

          if (_realItems.length > 0) {
            cartTitle.style.display = "none";
            if (sideCart.classList.contains("open")) {
              cartProgress.style.display = "block";
              if (headerMEssage) headerMEssage.style.display = "none";
            }
            
    
            var line = data.items.length;
            var count = 0;
            var color, fillColor, logourl, logo, outlineColor, text, estimatedDelivery;
    
            CartCount.classList.remove("hide");
    
            // Format original total price
            let subTotalStr = data.original_total_price.toString();
            let subTotalPrice = parseFloat(
              subTotalStr.slice(0, -2) + "." + subTotalStr.slice(-2)
            ).toFixed(2); // Convert to float and format to 2 decimal places
    
            // Format discounted subtotal price
            console.log(data,"datattttttt")
            let discountedSubTotalStr = data.total_price.toString();
            let discountedSubTotalPrice = parseFloat(
              discountedSubTotalStr.slice(0, -2) +
                "." +
                discountedSubTotalStr.slice(-2)
            ).toFixed(2); // Convert to float and format to 2 decimal places
    
            // Check if total price is equal to original total price
            if (data.total_price == data.original_total_price) {
              subTotal.innerHTML = currency + subTotalPrice; // Display original subtotal price
            } else {
              subTotal.innerHTML =
                currency +
                discountedSubTotalPrice +
                "<span>" +
                currency +
                subTotalPrice +
                "</span>"; // Display discounted subtotal price with original subtotal price
            }
    
    
            if (discountedSubTotalPrice >= 80) {
              shippingTotal.innerHTML = "FREE <span>$5.99</span>";
            } else {
              shippingTotal.innerHTML = "$5.99";
            }
            var itemHtml = "";
            data.items.reverse().forEach(function (item) {
              // Skip standalone addon products and the free gift item — hidden from cart display
              if (item.handle === 'decal-sheet-add-on' || item.handle === 'coach-sleeve-add-on') { line--; return; }
              if (handleGiftCard && item.handle === handleGiftCard) { line--; return; }
              
              if (item.product_id == 7901041328280) {
                count = count + item.quantity;
                  logo=null;
                logourl=null;
              }
              if (item.product_id == 8690237374616){
                   
                  logo=item.properties["Logo"];
                 count = count + item.quantity;
                  logourl=item.properties["_urlimage"]
                color = item.variant_options[1];
                fillColor = item.properties["Fill Color"];
                outlineColor = item.properties["Outline Color"];
              
                text =
                  item.properties && item.properties["Embroidery Number"]
                    ? item.properties["Embroidery Number"]
                    : "";
                estimatedDelivery = item.properties["Estimated Delivery"];
              }
              if (item.product_id == 7248891707544  ) {
                count = count + item.quantity;
                logo=null;
                logourl=null;
                color = item.variant_options[1];
                fillColor = item.properties["Fill Color"];
                outlineColor = item.properties["Outline Color"];
              
                text =
                  item.properties && item.properties["Embroidery Number"]
                    ? item.properties["Embroidery Number"]
                    : "";
                if (text && FLAG_TEXT_TO_EMOJI[text]) { text = FLAG_TEXT_TO_EMOJI[text]; }
                estimatedDelivery = item.properties["Estimated Delivery"];
                
                var productTitle = "Arm Sleeve";
              } else {
                var productTitle = item.product_title;
              }
              if (item.product_id == 8705389527192){
                count = count + item.quantity;
                logo=null;
                logourl=null;
                color = item.variant_options[1];
                fillColor = item.properties["Fill Color"];
                outlineColor = item.properties["Outline Color"];
              
                text =
                  item.properties && item.properties["Embroidery Number"]
                    ? item.properties["Embroidery Number"]
                    : "";
                estimatedDelivery = item.properties["Estimated Delivery"];
                 var productTitle = item.product_title;
              }
              if (item.product_id == 9098257203352){
                // Varsity Jacket
                count = count + item.quantity;
                logo=null;
                logourl=null;
                color = item.variant_options[1];
                fillColor = item.properties["Fill Color"];
                outlineColor = item.properties["Outline Color"];
                text =
                  item.properties && item.properties["Embroidery Number"]
                    ? item.properties["Embroidery Number"]
                    : "";
                if (text && FLAG_TEXT_TO_EMOJI[text]) { text = FLAG_TEXT_TO_EMOJI[text]; }
                estimatedDelivery = item.properties["Estimated Delivery"];
                var productTitle = item.product_title;
              }
    
              var recepientEmail = item.properties["Recipient email"];
              var deliveryDate = item.properties["Send on"];
              var dataOutlineColor =
                item.properties && item.properties["Outline Color"]
                  ? item.properties["Outline Color"]
                  : "";
              var dataFillColor =
                item.properties && item.properties["Fill Color"]
                  ? item.properties["Fill Color"]
                  : "";
             var datalogo =
                item.properties && item.properties["Logo"]
                  ? item.properties["Logo"]
                  : "";
              var dataText =
                item.properties && item.properties["Embroidery Number"]
                  ? item.properties["Embroidery Number"]
                  : "";
              // If text was remapped to a flag name (post-checkout bfcache), restore emoji for display
              if (dataText && FLAG_TEXT_TO_EMOJI[dataText]) { dataText = FLAG_TEXT_TO_EMOJI[dataText]; }
    
              const colorMap = {
                Royal: "rgb(0, 0, 204)",
                "Light Blue": "rgb(51, 204, 255)",
                "Neon Green": "rgb(2 249 54)",
                Navy: "rgb(0 5 116)",
                "Hot Pink": "rgb(246 33 87)",
                Orange: "rgb(255 64 0)",
              };
    
              if (colorMap[dataFillColor]) {
                dataFillColor = colorMap[dataFillColor];
              }
              if (colorMap[dataOutlineColor]) {
                dataOutlineColor = colorMap[dataOutlineColor];
              }
    
              itemHtml +=
                 '<div class="sc-line-item ' + item.handle + '" ' + ((item.handle == handleGiftCard) ? 'id="gift-card-line-item"' : '') + ' style="' + ((item.handle == handleGiftCard) ? 'position:relative;' : '') + '">' +
                '<div class="sc-item-img">' +
                '<img src="' +
                item.image +
                '" alt="' +
                item.title +
                '">';
              
            if (logo) { 
               const logoFileName = logo.toLowerCase().replace(/\s+/g, '-');
  const logoUrl = `https://customnumbered.com/cdn/shop/files/${logoFileName}.png`;
  itemHtml += `
    <div class="item-logo" style="display: block;">
      <div class="item-logom">
        <img src="${logoUrl}">
      </div>
    </div>`;
} else {
  itemHtml += '<p class="item-text" style="display: block;"></p>';
}  ;
              if (logo ){
                 if (dataText) {
                itemHtml +=
                  '<div class="item-text logo_c" style="display: block;"><div class="item-text-m " style="-webkit-text-stroke-color: ' +
                  dataOutlineColor +
                  "; color: " +
                  dataFillColor +
                  ';">' +
                  dataText +
                  "</div></div>";
              } else {
                itemHtml += '<p class="item-text" style="display: block;"></p>';
              }
              }else{
                
            
              if (dataText) {
                itemHtml +=
                  '<div class="item-text" style="display: block;"><div class="item-text-m" style="-webkit-text-stroke-color: ' +
                  dataOutlineColor +
                  "; color: " +
                  dataFillColor +
                  ';">' +
                  dataText +
                  "</div></div>";
              } else {
                itemHtml += '<p class="item-text" style="display: block;"></p>';
              }
                 }
              itemHtml +=
                "</div>" +
                '<div class="sc-item-title" style="' + ((item.handle == handleGiftCard) ? 'position:static;' : '') + '">' +
                '<img src="https://cdn.shopify.com/s/files/1/0472/7278/8120/files/trash_bin.png?v=1717515574" class="delete-icon" data-line="'+line+'" ' + ((item.handle == handleGiftCard) ? 'id="gift-card-del"' : '') + ' onclick="updateQuantity(' +
                line +
                ', 0)" />' +
                '<a href="' +
                item.url +
                '" class="cart__product-title" data-cart-item-title="">' +
                productTitle +
                "</a>";
    
              var variantTitle = item.variant_options.join(" ");
    
              // Split the variant options array
              var firstOption = item.variant_options[0];
              var restOptions = item.variant_options.slice(1).join(" ");
    
              // Create the HTML string with the first option bold
              if (firstOption != "Default Title"){
              itemHtml +=
                '<p class="">' +
                "<b>" +
                firstOption +
                "</b>" +
                " " +
                restOptions +
                "</p>";
              }
              else{
            
                if (item.handle == "gift-sticker-sheet"){
                  itemHtml += "<p>Buyers love these for helmets, water jugs, school supplies</p>"
                }
              }
              var properties = item.properties;
              if(item.handle != handleGiftCard) {
              itemHtml += '<div class="sc-properties">';
                 if (logo && logo != "Select Logo"){
                 itemHtml += '<p class="property">Logo: ' + logo + "</p>";
                
              }
              if (dataText) {
                itemHtml += '<p class="property">Text: ' + dataText + "</p>";
              } else {
                itemHtml += '<p class="property"></p>';
              }
              if (fillColor) {
                itemHtml += '<p class="property">Fill: ' + fillColor + "</p>";
              }
             
              if (outlineColor) {
                itemHtml += '<p class="property">Outline: ' + outlineColor + "</p>";
              }
             
              if (recepientEmail) {
                itemHtml +=
                  '<p class="property"> Recepient Email : ' +
                  recepientEmail +
                  "</p>";
              }
              if (deliveryDate) {
                itemHtml +=
                  '<p class="property"> Send On :' + deliveryDate + "</p>";
              }
              }
    
              // item.properties.forEach(function(property){
              //    itemHtml += '<p class="property">:'  + property.value + '</p>';
              // })
    
              // itemHtml += '<p class="property">Outline: ' + outlineColor + '</p>';
              itemHtml += "</div>";
    
              itemHtml += '<div class="price-date-quantity">';
              itemHtml += '<div class="price-and-date">';
               if (!properties["Pre-order item"]){
              if (properties["Estimated Delivery"]) {
                itemHtml +=
                  '<div class="sc-estimated">Delivers: ' +
                  properties["Estimated Delivery"] +
                  "</div>";
              }
               }
             if (properties["Pre-order item"]) {
 

  itemHtml +=
    '<div class="sc-estimated"><strong>Pre-order item:</strong> ' +
   properties["Pre-order item"] +
    "</div>";
     }
             
            
//               if (properties["Pre-order item"]) {
//   // Extract the date from the string and reformat it
//   const preOrderText = properties["Pre-order item"].replace(
//     /PRE-ORDER \(Ships Separately by (.*?)\)/,
//     "(Expected Ship Date $1)"
//   );

//   itemHtml +=
//     '<div class="sc-estimated"><strong>Pre-order item:</strong> ' +
//     preOrderText +
//     "</div>";
// } else if (properties["Estimated Delivery"]) {
//   itemHtml +=
//     '<div class="sc-estimated"><strong>Delivers:</strong>  ' +
//     properties["Estimated Delivery"] +
//     "</div>";
// }



              let priceStr = item.original_price.toString();
              let lineItemPrice = parseFloat(
                priceStr.slice(0, -2) + "." + priceStr.slice(-2)
              );
              let Tfinal = (lineItemPrice * item.quantity).toFixed(2);
    
              let discounted = item.discounted_price.toString();
              let lineItemPriceDiscounted = parseFloat(
                discounted.slice(0, -2) + "." + discounted.slice(-2)
              ); // Convert to float
              let discfinal = (lineItemPriceDiscounted * item.quantity).toFixed(2);
    
              if (item.original_price == item.line_price) {
                itemHtml +=
                  `<div class="sc-price l ${item.quantity}"><p>` +
                  currency +
                  Tfinal +
                  "</p></div>";
              } else {
                itemHtml +=
                  `<div class="sc-price k ${item.quantity}"><p>` +
                  currency +
                  discfinal +
                  "<span>" +
                  currency +
                  Tfinal +
                  "</span></p></div>";
              }
              itemHtml += "</div>";
    
              if(item.handle != handleGiftCard) {
              itemHtml +=
                '<div class="quantity-container">' +
                '<span id="minus" onclick="removeQty(event)"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 20 20"><path fill="#444" d="M17.543 11.029H2.1A1.032 1.032 0 0 1 1.071 10c0-.566.463-1.029 1.029-1.029h15.443c.566 0 1.029.463 1.029 1.029 0 .566-.463 1.029-1.029 1.029z"></path></svg></span>' +
                '<input readonly="" type="number" id="Quantity-product-template" name="quantity" value="' +
                item.quantity +
                '" min="1" pattern="[0-9]*" class="product-form__input product-form__input--quantity" data-quantity-input="" data-line="' +
                line +
                '">' +
                '<span id="plus" onclick="addQty(event)"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 20 20"><path fill="#444" d="M17.409 8.929h-6.695V2.258c0-.566-.506-1.029-1.071-1.029s-1.071.463-1.071 1.029v6.671H1.967C1.401 8.929.938 9.435.938 10s.463 1.071 1.029 1.071h6.605V17.7c0 .566.506 1.029 1.071 1.029s1.071-.463 1.071-1.029v-6.629h6.695c.566 0 1.029-.506 1.029-1.071s-.463-1.071-1.029-1.071z"></path></svg></span>' +
                "<div>";
              }
              itemHtml += "</div></div></div>";
    
              itemHtml += "</div>";
              itemHtml += "</div>";
    
              // === INLINE UPSELL PROMPTS ===
              var _addonMinusSvg = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 20 20"><path fill="#444" d="M17.543 11.029H2.1A1.032 1.032 0 0 1 1.071 10c0-.566.463-1.029 1.029-1.029h15.443c.566 0 1.029.463 1.029 1.029 0 .566-.463 1.029-1.029 1.029z"></path></svg>';
              var _addonPlusSvg = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 20 20"><path fill="#444" d="M17.409 8.929h-6.695V2.258c0-.566-.506-1.029-1.071-1.029s-1.071.463-1.071 1.029v6.671H1.967C1.401 8.929.938 9.435.938 10s.463 1.071 1.029 1.071h6.605V17.7c0 .566.506 1.029 1.071 1.029s1.071-.463 1.071-1.029v-6.629h6.695c.566 0 1.029-.506 1.029-1.071s-.463-1.071-1.029-1.071z"></path></svg>';
              if (item.handle === 'gift-sticker-sheet') {
                var _decalAddon = data.items.find(function(i) { return i.handle === 'decal-sheet-add-on'; });
                var _decalKey = _decalAddon ? _decalAddon.key : '';
                var _decalQty = _decalAddon ? _decalAddon.quantity : 0;
                var _decalChecked = _decalAddon ? 'checked' : '';
                var _decalReveal = _decalAddon ? 'display:flex' : 'display:none';
                // Map the inline price to the live product price (injected by side-cart.liquid); fall back to the cart line price.
                var _decalPriceCents = (window.CN_ADDON_PRICES && window.CN_ADDON_PRICES['decal-sheet-add-on']) || (_decalAddon ? _decalAddon.price : 0);
                var _decalPriceStr = _decalPriceCents ? '+$' + (_decalPriceCents / 100).toFixed(2) : '';
                itemHtml += '<div class="sc-addon-inline" data-addon-handle="decal-sheet-add-on" data-addon-key="' + _decalKey + '">' +
                  '<label class="addon-check-wrap">' +
                  '<input type="checkbox" class="addon-check" ' + _decalChecked + ' onchange="addonToggle(event)">' +
                  '<span class="addon-inline-label">Add an additional decal sheet? <span class="addon-inline-price">' + _decalPriceStr + '</span></span>' +
                  '</label>' +
                  '<div class="addon-qty-reveal" style="' + _decalReveal + '">' +
                  '<span onclick="addonRemoveQty(event)">' + _addonMinusSvg + '</span>' +
                  '<input readonly type="number" value="' + (_decalQty || 1) + '" min="1" class="product-form__input product-form__input--quantity addon-qty-input">' +
                  '<span onclick="addonAddQty(event)">' + _addonPlusSvg + '</span>' +
                  '</div>' +
                  '</div>';
              }
              line--;
            });
    
            var firstItemSize = data.items[0].variant_options[0];
            cartItems.innerHTML = itemHtml;

            // === COACH SLEEVE ADDON (tied to upsell_free_gift, not a cart line item) ===
            var _coachAddonEl = document.querySelector('.sc-addon-coach');
            if (_coachAddonEl) {
              var _sleeveAddon = data.items.find(function(i) { return i.handle === 'coach-sleeve-add-on'; });
              var _sleeveKey = _sleeveAddon ? _sleeveAddon.key : '';
              var _sleeveQty = _sleeveAddon ? _sleeveAddon.quantity : 0;
              var _sleeveChecked = _sleeveAddon ? 'checked' : '';
              var _sleeveReveal = _sleeveAddon ? 'display:flex' : 'display:none';
              var _cMinusSvg = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 20 20"><path fill="#444" d="M17.543 11.029H2.1A1.032 1.032 0 0 1 1.071 10c0-.566.463-1.029 1.029-1.029h15.443c.566 0 1.029.463 1.029 1.029 0 .566-.463 1.029-1.029 1.029z"></path></svg>';
              var _cPlusSvg = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 20 20"><path fill="#444" d="M17.409 8.929h-6.695V2.258c0-.566-.506-1.029-1.071-1.029s-1.071.463-1.071 1.029v6.671H1.967C1.401 8.929.938 9.435.938 10s.463 1.071 1.029 1.071h6.605V17.7c0 .566.506 1.029 1.071 1.029s1.071-.463 1.071-1.029v-6.629h6.695c.566 0 1.029-.506 1.029-1.071s-.463-1.071-1.029-1.071z"></path></svg>';
              _coachAddonEl.innerHTML = '<div class="sc-addon-inline" data-addon-handle="coach-sleeve-add-on" data-addon-key="' + _sleeveKey + '">' +
                '<label class="addon-check-wrap">' +
                '<input type="checkbox" class="addon-check" ' + _sleeveChecked + ' onchange="addonToggle(event)">' +
                '<span class="addon-inline-label">Add an additional matching coach sleeve? <span class="addon-inline-price">+$17.99</span></span>' +
                '</label>' +
                '<div class="addon-qty-reveal" style="' + _sleeveReveal + '">' +
                '<span onclick="addonRemoveQty(event)">' + _cMinusSvg + '</span>' +
                '<input readonly type="number" value="' + (_sleeveQty || 1) + '" min="1" class="product-form__input product-form__input--quantity addon-qty-input">' +
                '<span onclick="addonAddQty(event)">' + _cPlusSvg + '</span>' +
                '</div>' +
                '</div>';
              var _giftDiv = document.querySelector('.upsell_free_gift');
              _coachAddonEl.style.display = (_giftDiv && _giftDiv.style.display !== 'none') ? 'block' : 'none';
            }
           
            var iddata= data.items[data.items.length - 1].product_id;
            if (data.items[data.items.length - 1].product_id == "8611941122200"){
                 iddata= data.items[data.items.length - 2].product_id;
            }
            _lastTriggerProductId = iddata;

            if (iddata == "8705389527192"){
              updateUpsellssec(
              count,
              color,
              fillColor,
              outlineColor,
              text,
              estimatedDelivery,
              firstItemSize,
              suggestRemaining
            ).then((result) => {
              var suggestions = document.querySelector(".side-cart .suggestions");
              if(result){
                suggestions.innerHTML = result;
              }
              
            });

            }
            else{

         
            
          
            updateUpsells(
              count,
              color,
              fillColor,
              outlineColor,
              text,
              estimatedDelivery,
              firstItemSize,
              suggestRemaining
            ).then((result) => {
              var suggestions = document.querySelector(".side-cart .suggestions");
              if(result){
                suggestions.innerHTML = result;
              }
              
            });
            }

            
            sideCart.scrollTo({
              top: 0,
              behavior: "smooth",
            });
            cartProgress.style.top = "0px";
            var upperHeight = cartProgress.offsetHeight;
            cartContent.style.marginTop = upperHeight + 10 + "px";
            if (window.innerWidth <= 500) {
              var lowerHeight = cartFooter.offsetHeight;
              cartContent.style.marginBottom = lowerHeight + "px";
            }
          } else {
            cartItems.innerHTML = '<p class="empty">No product in cart.</p>';
            suggestions.innerHTML = "";
            upsells.style.display = "none";
            var _emptyCoach = document.querySelector('.sc-addon-coach');
            if (_emptyCoach) _emptyCoach.style.display = 'none';
            cartFooter.style.display = "none";
            if (sideCart.classList.contains("open")) {
              cartProgress.style.display = "block";
            }
            cartTitle.style.display = "block";
            cartContent.style.marginBottom = 0;
            cartProgress.style.top = "33px";
            var upperHeight = cartProgress.offsetHeight;
            cartContent.style.marginTop = upperHeight + 100 + "px";
    
            updateUpsells(0, "", "", "", "", "", "", null).then((result) => {
              console.log(result);
            });;
            CartCount.classList.add("hide");
          }
    
          dataCartCount.innerText = data.item_count;
          sideCartInner.style.opacity = 1;
          ajaxLoader.style.display = "none";
        })
        .catch((error) => {
          console.error("Error getting cart data:", error);
        });
    }
    
    function removeQty(event) {
      var inputField = event.target.closest(".quantity-container").querySelector("input");
      var currentValue = parseInt(inputField.value);
      var newValue = currentValue - 1;
      if (newValue >= 0) {
        inputField.value = newValue;
    
        var line = inputField.getAttribute("data-line");
        updateQuantity(line, newValue);
      }
    }
    
    function addQty(event) {
      var inputField = event.target.closest(".quantity-container").querySelector("input");
      var currentValue = parseInt(inputField.value);
      var newValue = currentValue + 1;
    
      inputField.value = newValue;
      var line = inputField.getAttribute("data-line");
      updateQuantity(line, newValue);
    }
    
    var _addonVariantCache = {};
    function addonFetchVariantId(handle, callback) {
      if (_addonVariantCache[handle]) { callback(_addonVariantCache[handle]); return; }
      fetch('/products/' + handle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(p) {
          var v = p.variants[0].id;
          _addonVariantCache[handle] = v;
          callback(v);
        })
        .catch(function(err) { console.error('Addon fetch error:', err); });
    }

    function addonRefreshSubtotal(cart) {
      var currency = document.querySelector('.side-cart').getAttribute('data-currency');
      var subTotalEl = document.getElementById('sc-subtotal');
      if (subTotalEl) {
        var ts = cart.total_price.toString();
        subTotalEl.innerHTML = currency + parseFloat(ts.slice(0,-2)+'.'+ts.slice(-2)).toFixed(2);
      }
      var shippingEl = document.getElementById('sc-shipping');
      if (shippingEl) {
        var tp = parseFloat(cart.total_price.toString().slice(0,-2)+'.'+cart.total_price.toString().slice(-2));
        shippingEl.innerHTML = tp >= 80 ? 'FREE <span>$5.99</span>' : '$5.99';
      }
      var countEl = document.querySelector('#CartCount span[data-cart-count]');
      if (countEl) countEl.innerText = cart.item_count;
    }

    function addonToggle(event) {
      var checkbox = event.target;
      var container = checkbox.closest('.sc-addon-inline');
      var qtyReveal = container.querySelector('.addon-qty-reveal');
      var qtyInput = container.querySelector('.addon-qty-input');
      var handle = container.getAttribute('data-addon-handle');
      var addonKey = container.getAttribute('data-addon-key');
      if (checkbox.checked) {
        qtyInput.value = 1;
        qtyReveal.style.display = 'flex';
        addonFetchVariantId(handle, function(variantId) {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          }).then(function(r) { return r.json(); })
          .then(function(resp) {
            var newKey = resp.items ? resp.items[0].key : '';
            container.setAttribute('data-addon-key', newKey);
            updateCartDrawer();
          })
          .catch(function(err) { console.error('Addon add error:', err); });
        });
      } else {
        qtyReveal.style.display = 'none';
        if (addonKey) {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: addonKey, quantity: 0 })
          }).then(function(r) { return r.json(); })
          .then(function() {
            container.setAttribute('data-addon-key', '');
            updateCartDrawer();
          })
          .catch(function(err) { console.error('Addon remove error:', err); });
        }
      }
    }

    function addonRemoveQty(event) {
      var container = event.target.closest('.sc-addon-inline');
      var qtyInput = container.querySelector('.addon-qty-input');
      var checkbox = container.querySelector('.addon-check');
      var qtyReveal = container.querySelector('.addon-qty-reveal');
      var addonKey = container.getAttribute('data-addon-key');
      var qty = parseInt(qtyInput.value) || 1;
      qty--;
      if (qty < 1) {
        checkbox.checked = false;
        qtyReveal.style.display = 'none';
        if (addonKey) {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: addonKey, quantity: 0 })
          }).then(function(r) { return r.json(); })
          .then(function() {
            container.setAttribute('data-addon-key', '');
            updateCartDrawer();
          });
        }
      } else {
        qtyInput.value = qty;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: addonKey, quantity: qty })
        }).then(function(r) { return r.json(); }).then(function() { updateCartDrawer(); });
      }
    }

    function addonAddQty(event) {
      var container = event.target.closest('.sc-addon-inline');
      var qtyInput = container.querySelector('.addon-qty-input');
      var addonKey = container.getAttribute('data-addon-key');
      var qty = parseInt(qtyInput.value) || 1;
      qty++;
      qtyInput.value = qty;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: addonKey, quantity: qty })
      }).then(function(r) { return r.json(); }).then(function() { updateCartDrawer(); });
    }
    
    function updateQuantity(line, qty, update = 0) {
    
      var sideCart = document.querySelector(".side-cart .side-cart-inner");
    
      var ajaxLoader = document.querySelector(".side-cart .sc-loading");
      ajaxLoader.style.display = "block";
    
      sideCart.style.opacity = 0.5;
    
      fetch(window.Shopify.routes.root + "cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          line: line,
          quantity: qty,
        }),
      })
      .then((response) => {
        console.log(response);
    
        if(update == 0) {
        updateCartDrawer();
        sideCart.classList.add("open");
        var bodyClass = document.body.className;
        if (bodyClass.indexOf("body-no-scroll") === -1) {
          document.body.className += " body-no-scroll";
        }
        }
        else {
          var giftLineItem = document.getElementById('gift-card-line-item');
          if(giftLineItem) {
            // giftLineItem.style.display = 'none';
            giftLineItem.remove();
          }
        } 
      })
      .catch((error) => {
        console.error("Error:", error);
      });
    }

    //updatewristmain
  async function updateUpsellssec(
      count,
      desiredColor,
      fillColor,
      outlineColor,
      text,
      estimatedDelivery,
      firstItemSize,
      suggestRemaining
    ) {
      console.log("sectionsecone")
      var message = document.querySelectorAll(".sc-upsell-msg");
      var bar = document.querySelector(".progress-container");
      var progress = document.querySelectorAll(".progress-container .progress");
      var suggestions = document.querySelector(".side-cart .suggestions");
      let discountThreshold = document.querySelector('div.discount__price');
      var newFillColor, newOutlineColor;
    
      let upsellItem = "";
    
      bar.style.display = "block";
      message.forEach(function (ele) {
        ele.style.display = "block";
      });
    
    
      if (count == 0) {
        message.forEach(function (ele) {
          ele.innerHTML =
            // "Buy 2 get 20% off & free ship. Add more to save up to 50%.";
            "40% off 4 + FREE SHIPPING.  50% off 6 + FREE EXPRESS.";
          
          
    
        });
        bar.style.display = "block";
        message.style.display = "block";
        progress.forEach(function (ele) {
          ele.style.width = "0px";
        });
      } else if (count == 1) {
        message.forEach(function (ele) {
          ele.innerHTML = 
            // "Add <b>1</b> more item for <b>20% OFF & FREE SHIP</b>";
             "Add 1 more for 20% off, or 2 more 30% off.";
    
        });
        progress.forEach(function (ele) {
          ele.style.width = "15%";
    
          ele.style.background = "#fff";
        });
      } else if (count == 2) {
        message.forEach(function (ele) {
          ele.innerHTML =
            // "You unlocked 20% off & free ship! Add <b>1</b> item for 30% off!";
             "Add 1 more for 30% off.";
    
        });
        progress.forEach(function (ele) {
          ele.style.width = "30%";
    
          ele.style.background = "#01ffa8";
        });
      } else if (count == 3) {
        if (discountThreshold) {
        message.forEach(function (ele) {
          ele.innerHTML =
            "Add 1 more for 40% off & FREE SHIP!";
    
        });
          }
        else {
      message.forEach(function (ele) {
      ele.innerHTML = "Add 1 more for 40% off";
      });
      }
        progress.forEach(function (ele) {
          ele.style.width = "54%";
    
          ele.style.background =
            "linear-gradient(to right, #01ffa8 0%, #33ccff 70%)";
        });
      } else if (count == 4) {
        message.forEach(function (ele) {
          ele.innerHTML =
            
            // "You unlocked 40% off! Add <b>2</b> more items for 50% off!";
             "Add 2 more for 50% off & free express service!";
    
        });
        progress.forEach(function (ele) {
          ele.style.width = "80%";
    
          ele.style.background =
            "linear-gradient(to right, #01ffa8 0%, #33ccff 70%, #9417de 90%)";
        });
      } else if (count == 5) {
        message.forEach(function (ele) {
          ele.innerHTML = 
            "You're saving 40%. Just <b>1</b> more item for 50% off & free express service!";
        });
        progress.forEach(function (ele) {
          ele.style.width = "86%";
    
          ele.style.background =
            "linear-gradient(to right, #01ffa8 0%, #33ccff 60%, #9417de 80%)";
        });
      } else if (count >= 6) {
        message.forEach(function (ele) {
          ele.innerHTML = "Well played. You acheived our maximum discount!";
        });
        progress.forEach(function (ele) {
          ele.style.width = "100%";
          ele.style.background =
            "linear-gradient(to right, rgb(1, 255, 168) 0%, rgb(51, 204, 255) 29%,rgb(148, 23, 222) 79%, rgb(255, 40, 237) 89%)";
        });
      }
    
      if (suggestRemaining) {
        return;
      }
    
      if (fillColor == "Light Blue") {
        newFillColor = "Ice Blue";
      } else {
        newFillColor = fillColor;
      }
      if (outlineColor == "Light Blue") {
        newOutlineColor = "Ice Blue";
      } else {
        newOutlineColor = outlineColor;
      }
       
      if (desiredColor) {
     
        try {
          const response = await fetch("/products/custom-numbered-compression-arm-sleeve.js", {
            method: "GET",
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              Accept: "application/json",
            },
          });
    
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
    
          const data = await response.json();
    
            // Assuming the product object has a 'variants' array
         
            const variants = data.variants;
    
            let colors, colors2, color3, colors4, colorsOptions;
    
            if (text) {
              colorsOptions = [
                "No Color",
                "White",
                "Black",
                "Red",
                "Orange",
                "Yellow",
                "Neon Green",
                "Light Blue",
                "Royal",
                "Navy",
                "Hot Pink",
              ];
              colors = [
                desiredColor,
                newFillColor,
               
              ];
               colors4=[desiredColor, newFillColor, newOutlineColor, desiredColor ]
              
              colors3=[newOutlineColor, "Black", desiredColor,]
              colors2 = ["Pink Sprinkles", desiredColor, "Blue Sprinkles"];
            } else {
              colors = [desiredColor, "White", "Black", "Ice Blue", "Red", "Royal"];
              colors2 = [];
            }
                  try {
          const response = await fetch("/products/custom-wristband.js", {
            method: "GET",
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              Accept: "application/json",
            },
          });
    
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
    
          const datas = await response.json();
    
            // Assuming the product object has a 'variants' array
         
            const variantsec = datas.variants;

          
           
           colors4.forEach((color, colorIndex) => {



               const matchingVariantssec = variantsec.filter(
                (variant) => variant.option2 === color && variant.available
              );
              if (text) {
                 var  newtext= text;
               if (colorIndex === 0) {
                  dataFillColor = fillColor;
                  dataOutlineColor = outlineColor;
                }
                if (colorIndex === 1) {
                  dataFillColor = outlineColor;
                 
                  if (!colorsOptions.includes(desiredColor)) {
                    dataOutlineColor = "Black";
                  }
                  
                   else {
                    dataOutlineColor = desiredColor;
                  }
                  if (desiredColor == 'Ice Blue'){
                    dataOutlineColor = "Light Blue";
                   }
                }
                  if (colorIndex === 2) {
                  if (!colorsOptions.includes(desiredColor)) {
                    dataFillColor = "Black";
                  } else {
                    dataFillColor = desiredColor;
                  }
                  dataOutlineColor = fillColor;
                }
                if (colorIndex === 3) {
                  dataFillColor = fillColor;
                  dataOutlineColor = outlineColor;
                  newtext = "†";
                }
              } else {
                dataFillColor = fillColor;
                dataOutlineColor = outlineColor;
              }

              var cssFillColor = dataFillColor;
              var cssOutlineColor = dataOutlineColor;
    
              const colorMap = {
                Royal: "rgb(0, 0, 204)",
                "Light Blue": "rgb(51, 204, 255)",
                "Neon Green": "rgb(2 249 54)",
                Navy: "rgb(0 5 116)",
                "Hot Pink": "rgb(246 33 87)",
                Orange: "rgb(255 64 0)",
              };
              if (colorMap[dataFillColor]) {
                cssFillColor = colorMap[cssFillColor];
              }
              if (colorMap[dataOutlineColor]) {
                cssOutlineColor = colorMap[cssOutlineColor];
              }
              if (matchingVariantssec.length > 0) {
                upsellItem +=
                  '<div class="suggest-item thirswrist  + ' + desiredColor  + ' " data-text="' +
                  newtext +
                  '" data-fill="' +
                  dataFillColor +
                  '" data-outline="' +
                  dataOutlineColor +
                  '" data-delivery="' +
                  estimatedDelivery +
                  '" data-index="' +
                  colorIndex +
                  '">' +
                  '<img class="product-img" src="' +
                  matchingVariantssec[0].featured_image.src +
                  '" alt="' +
                  matchingVariantssec[0].name +
                  '">';
                if (newtext) {
                  upsellItem +=
                    '<div class="item-text" style="display: block;"><div class="item-text-m" style="-webkit-text-stroke-color: ' +
                    cssOutlineColor +
                    "; color: " +
                    cssFillColor +
                    ';">' +
                    newtext +
                    "</div></div>";
                }
                upsellItem += '<div class="item-action forsize">';
    
                var noneMatch = matchingVariantssec.every(
                  (variant) => variant.option1 !== firstItemSize
                );
                
                matchingVariantssec.forEach(function (variant, index) {
                  var checked = firstItemSize == variant.option1 ? "checked" : "";
                  if (noneMatch && index == 0) {
                    var checked = "checked";
                  }

               
                var productId=datas.id;
                  if(productId == "42306424078488"){
                var variantPreorder=window.ta.products[datas.id].variants[variant.id];
                 
                  // console.log(window.ta.products[data.id].variants[variant.id])
                
                if (variantPreorder.quantity <= 0 ){
                   
                 var templateId=window.ta.products[data.id].variants[variant.id].config.settingsTemplate;
                 var preorder=true;
                  var preorderKey=window.ta.settings[templateId].cart.labelText.key;
                  var preorderValue=window.ta.settings[templateId].cart.labelText.value;
                 
                  
                  }
                  
                  
           
                  var preorderAttributes = preorder ? ` preorder="true" preorderKey="${preorderKey}" preorderValue="${preorderValue}"` : '';
                  var preorderLabelText = preorder ? '<br><span class="preorder-text">(preorder)</span>' : '';
                  }
                  else{
                      var preorderAttributes ='';
                  var preorderLabelText ='';
                  }
                  upsellItem +=
                    '<div data-value="' +
                    variant.option1 +
                    '" class="Size_name_ofoption swatch-element" onclick="changeVariant(event)">' +
                    '<input class="optz" data-index="option1" type="radio" value="' +
                    variant.option1 +
                    '" ' +
                    checked +
                    ' data-variantid="' +
                    variant.id +
                    '"' + preorderAttributes + '>' +
                    '<label for="">' +
                    variant.option1 +
                    preorderLabelText +
                    "</label>" +
                    "</div>";
                });
              
    
                upsellItem +=
                  '<div class="sc-add-to-cart">' +
                  '<a href="#" onclick="addSuggestedItemToCartPair(event)" data-variantid="' +
                  matchingVariantssec[0].id +
                  '" class="sc-icon-plus"> <div class="innerbtn"> ADD PAIR </div></a> <a href="#" onclick="addSuggestedItemToCart(event)" data-variantid="' +
                  matchingVariantssec[0].id +
                  '" class="sc-icon-plus"><div class="innerbtn"> ADD ONE </div></a>' + "</div>";
    
                upsellItem += "</div></div>";
              }



           })

           } catch (error) {
             console.error("Error fetching or processing product data:", error);
           }

           // ── JACKET render ──
           if (text) {
             const jacketHtml = await fetchJacketProductHtml(
               desiredColor,
               fillColor,
               outlineColor,
               text,
               estimatedDelivery,
               colorsOptions
             );
             if (jacketHtml) {
               upsellItem += jacketHtml;
             }
           }
           // ── END JACKET render ──
    
            colors.forEach((color, colorIndex) => {
             
              const matchingVariants = variants.filter(
                (variant) => variant.option2 === color && variant.available
              );
    
              if (text) {
                if (colorIndex === 0) {
                  dataFillColor = fillColor;
                  dataOutlineColor = outlineColor;
                }
                if (colorIndex === 1) {
                  dataFillColor = outlineColor;
                  if (!colorsOptions.includes(desiredColor)) {
                    dataOutlineColor = "Black";
                  } else {
                    dataOutlineColor = desiredColor;
                  }
                }
                if (colorIndex === 2) {
                  if (!colorsOptions.includes(desiredColor)) {
                    dataFillColor = "Black";
                  } else {
                    dataFillColor = desiredColor;
                  }
                  dataOutlineColor = fillColor;
                }
                if (colorIndex === 3) {
                  if (!colorsOptions.includes(desiredColor)) {
                    dataFillColor = "White";
                  } else {
                    dataFillColor = desiredColor;
                  }
                  dataOutlineColor = fillColor;
                }
                if (colorIndex === 4) {
                  dataFillColor = outlineColor;
                  dataOutlineColor = fillColor;
                }
              } else {
                dataFillColor = fillColor;
                dataOutlineColor = outlineColor;
              }
    
              var cssFillColor = dataFillColor;
              var cssOutlineColor = dataOutlineColor;
    
              const colorMap = {
                Royal: "rgb(0, 0, 204)",
                "Light Blue": "rgb(51, 204, 255)",
                "Neon Green": "rgb(2 249 54)",
                Navy: "rgb(0 5 116)",
                "Hot Pink": "rgb(246 33 87)",
                Orange: "rgb(255 64 0)",
              };
              if (colorMap[dataFillColor]) {
                cssFillColor = colorMap[cssFillColor];
              }
              if (colorMap[dataOutlineColor]) {
                cssOutlineColor = colorMap[cssOutlineColor];
              }
             
              if (matchingVariants.length > 0) {
                upsellItem +=
                  '<div class="suggest-item this" data-text="' +
                  text +
                  '" data-fill="' +
                  dataFillColor +
                  '" data-outline="' +
                  dataOutlineColor +
                  '" data-delivery="' +
                  estimatedDelivery +
                  '" data-index="' +
                  colorIndex +
                  '">' +
                  '<img class="product-img" src="' +
                  matchingVariants[0].featured_image.src +
                  '" alt="' +
                  matchingVariants[0].name +
                  '">';
                if (text) {
                  upsellItem +=
                    '<div class="item-text" style="display: block;"><div class="item-text-m" style="-webkit-text-stroke-color: ' +
                    cssOutlineColor +
                    "; color: " +
                    cssFillColor +
                    ';">' +
                    text +
                    "</div></div>";
                }
                upsellItem += '<div class="item-action forsize">';
    
                var noneMatch = matchingVariants.every(
                  (variant) => variant.option1 !== firstItemSize
                );
                
                matchingVariants.forEach(function (variant, index) {
                  var checked = firstItemSize == variant.option1 ? "checked" : "";
                  if (noneMatch && index == 0) {
                    var checked = "checked";
                  }

               
                var productId=data.id;
                  if(productId == "42306424078488"){
                var variantPreorder=window.ta.products[data.id].variants[variant.id];
                 
                  // console.log(window.ta.products[data.id].variants[variant.id])
                
                if (variantPreorder.quantity <= 0 ){
                   
                 var templateId=window.ta.products[data.id].variants[variant.id].config.settingsTemplate;
                 var preorder=true;
                  var preorderKey=window.ta.settings[templateId].cart.labelText.key;
                  var preorderValue=window.ta.settings[templateId].cart.labelText.value;
                 
                  
                  }
                  
                  
           
                  var preorderAttributes = preorder ? ` preorder="true" preorderKey="${preorderKey}" preorderValue="${preorderValue}"` : '';
                  var preorderLabelText = preorder ? '<br><span class="preorder-text">(preorder)</span>' : '';
                  }
                  else{
                      var preorderAttributes ='';
                  var preorderLabelText ='';
                  }
                  upsellItem +=
                    '<div data-value="' +
                    variant.option1 +
                    '" class="Size_name_ofoption swatch-element" onclick="changeVariant(event)">' +
                    '<input class="optz" data-index="option1" type="radio" value="' +
                    variant.option1 +
                    '" ' +
                    checked +
                    ' data-variantid="' +
                    variant.id +
                    '"' + preorderAttributes + '>' +
                    '<label for="">' +
                    variant.option1 +
                    preorderLabelText +
                    "</label>" +
                    "</div>";
                });
    
                upsellItem +=
                  '<div class="sc-add-to-cart">' +
                  '<a href="#" onclick="addSuggestedItemToCartPair(event)" data-variantid="' +
                  matchingVariants[0].id +
                  '" class="sc-icon-plus"> <div class="innerbtn"> ADD PAIR </div></a> <a href="#" onclick="addSuggestedItemToCart(event)" data-variantid="' +
                  matchingVariants[0].id +
                  '" class="sc-icon-plus"><div class="innerbtn"> ADD ONE </div></a>' + "</div>";
    
                upsellItem += "</div></div>";
              }
            });

      

          
          colors3.forEach((color, colorIndex) => {
          const matchingVariants = variants.filter(
                (variant) => variant.option2 === color && variant.available
              );
            if (text) {
              if (colorIndex === 0) {
                 if (!colorsOptions.includes(desiredColor)) {
                    dataFillColor = "Black";
                  } else {
                    dataFillColor = desiredColor;
                  }
                  dataOutlineColor = fillColor;
                }
                if (colorIndex === 1) {
                 if (!colorsOptions.includes(desiredColor)) {
                    dataFillColor = "White";
                  } else {
                    dataFillColor = desiredColor;
                  }
                  dataOutlineColor = fillColor;
                }
                if (colorIndex === 2) {
                   dataFillColor = outlineColor;
                  dataOutlineColor = fillColor;
                }

            }
            else{
              dataFillColor = fillColor;
              dataOutlineColor = outlineColor;
            }

            var cssFillColor = dataFillColor;
              var cssOutlineColor = dataOutlineColor;
    
              const colorMap = {
                Royal: "rgb(0, 0, 204)",
                "Light Blue": "rgb(51, 204, 255)",
                "Neon Green": "rgb(2 249 54)",
                Navy: "rgb(0 5 116)",
                "Hot Pink": "rgb(246 33 87)",
                Orange: "rgb(255 64 0)",
              };
              if (colorMap[dataFillColor]) {
                cssFillColor = colorMap[cssFillColor];
              }
              if (colorMap[dataOutlineColor]) {
                cssOutlineColor = colorMap[cssOutlineColor];
              }

              if (matchingVariants.length > 0) {
                upsellItem +=
                  '<div class="suggest-item this" data-text="' +
                  text +
                  '" data-fill="' +
                  dataFillColor +
                  '" data-outline="' +
                  dataOutlineColor +
                  '" data-delivery="' +
                  estimatedDelivery +
                  '" data-index="' +
                  colorIndex +
                  '">' +
                  '<img class="product-img" src="' +
                  matchingVariants[0].featured_image.src +
                  '" alt="' +
                  matchingVariants[0].name +
                  '">';
                if (text) {
                  upsellItem +=
                    '<div class="item-text" style="display: block;"><div class="item-text-m" style="-webkit-text-stroke-color: ' +
                    cssOutlineColor +
                    "; color: " +
                    cssFillColor +
                    ';">' +
                    text +
                    "</div></div>";
                }
                upsellItem += '<div class="item-action forsize">';
    
                var noneMatch = matchingVariants.every(
                  (variant) => variant.option1 !== firstItemSize
                );
                
                matchingVariants.forEach(function (variant, index) {
                  var checked = firstItemSize == variant.option1 ? "checked" : "";
                  if (noneMatch && index == 0) {
                    var checked = "checked";
                  }

               
                var productId=data.id;
                  if(productId == "42306424078488"){
                var variantPreorder=window.ta.products[data.id].variants[variant.id];
                 
                  // console.log(window.ta.products[data.id].variants[variant.id])
                
                if (variantPreorder.quantity <= 0 ){
                   
                 var templateId=window.ta.products[data.id].variants[variant.id].config.settingsTemplate;
                 var preorder=true;
                  var preorderKey=window.ta.settings[templateId].cart.labelText.key;
                  var preorderValue=window.ta.settings[templateId].cart.labelText.value;
                 
                  
                  }
                  
                  
           
                  var preorderAttributes = preorder ? ` preorder="true" preorderKey="${preorderKey}" preorderValue="${preorderValue}"` : '';
                  var preorderLabelText = preorder ? '<br><span class="preorder-text">(preorder)</span>' : '';
                  }
                  else{
                      var preorderAttributes ='';
                  var preorderLabelText ='';
                  }
                  upsellItem +=
                    '<div data-value="' +
                    variant.option1 +
                    '" class="Size_name_ofoption swatch-element" onclick="changeVariant(event)">' +
                    '<input class="optz" data-index="option1" type="radio" value="' +
                    variant.option1 +
                    '" ' +
                    checked +
                    ' data-variantid="' +
                    variant.id +
                    '"' + preorderAttributes + '>' +
                    '<label for="">' +
                    variant.option1 +
                    preorderLabelText +
                    "</label>" +
                    "</div>";
                });
    
                upsellItem +=
                  '<div class="sc-add-to-cart">' +
                  '<a href="#" onclick="addSuggestedItemToCartPair(event)" data-variantid="' +
                  matchingVariants[0].id +
                  '" class="sc-icon-plus"> <div class="innerbtn"> ADD PAIR </div></a> <a href="#" onclick="addSuggestedItemToCart(event)" data-variantid="' +
                  matchingVariants[0].id +
                  '" class="sc-icon-plus"><div class="innerbtn"> ADD ONE </div></a>' + "</div>";
    
                upsellItem += "</div></div>";
              }

            


          })
    
            let upsellItemLast = "";
    
            var cssFillColorBeany = fillColor;
            var cssOutlineColorBeany = outlineColor;
    
            const colorMap = {
              Royal: "rgb(0, 0, 204)",
              "Light Blue": "rgb(51, 204, 255)",
              "Neon Green": "rgb(2 249 54)",
              Navy: "rgb(0 5 116)",
              "Hot Pink": "rgb(246 33 87)",
              Orange: "rgb(255 64 0)",
            };
            if (colorMap[fillColor]) {
              cssFillColorBeany = colorMap[cssFillColorBeany];
            }
            if (colorMap[outlineColor]) {
              cssOutlineColorBeany = colorMap[cssOutlineColorBeany];
            }
    
          if (text) {
            const html = await fetchBeanieProductHtml(
              "Black",
              text,
              fillColor,
              outlineColor,
              estimatedDelivery,
              colorMap[fillColor] || fillColor,
              colorMap[outlineColor] || outlineColor
            );
    
            if (html) {
              upsellItem += html;
            }
          }
    
            colors2.forEach((color, colorIndex) => {
              const matchingVariants = variants.filter(
                (variant) => variant.option2 === color && variant.available
              );
    
              if (text) {
                var newtext = text;
                if (colorIndex === 0) {
                  dataFillColor = 'White';
                  dataOutlineColor = 'Neon Green';
                }
                if (colorIndex === 1) {
                  dataFillColor = fillColor;
                  dataOutlineColor = outlineColor;
                  newtext = "†";
                }
                if (colorIndex === 2) {
                  dataFillColor = 'White';
                  dataOutlineColor = 'Hot Pink';
                }
              } else {
                dataFillColor = fillColor;
                dataOutlineColor = outlineColor;
              }
    
              var cssFillColor = dataFillColor;
              var cssOutlineColor = dataOutlineColor;
    
              const colorMap = {
                Royal: "rgb(0, 0, 204)",
                "Light Blue": "rgb(51, 204, 255)",
                "Neon Green": "rgb(2 249 54)",
                Navy: "rgb(0 5 116)",
                "Hot Pink": "rgb(246 33 87)",
                Orange: "rgb(255 64 0)",
              };
              if (colorMap[dataFillColor]) {
                cssFillColor = colorMap[cssFillColor];
              }
              if (colorMap[dataOutlineColor]) {
                cssOutlineColor = colorMap[cssOutlineColor];
              }
    
              if (matchingVariants.length > 0) {
                upsellItem +=
                  '<div class="suggest-item thistwo" data-text="' +
                  newtext +
                  '" data-fill="' +
                  dataFillColor +
                  '" data-outline="' +
                  dataOutlineColor +
                  '" data-delivery="' +
                  estimatedDelivery +
                  '" data-index="' +
                  colorIndex +
                  '">' +
                  '<img class="product-img" src="' +
                  matchingVariants[0].featured_image.src +
                  '" alt="' +
                  matchingVariants[0].name +
                  '">';
                if (newtext) {
                  upsellItem +=
                    '<div class="item-text" style="display: block;"><div class="item-text-m" style="-webkit-text-stroke-color: ' +
                    cssOutlineColor +
                    "; color: " +
                    cssFillColor +
                    ';">' +
                    newtext +
                    "</div></div>";
                }
                upsellItem += '<div class="item-action forsize">';
    
                var noneMatch = matchingVariants.every(
                  (variant) => variant.option1 !== firstItemSize
                );
    
                matchingVariants.forEach(function (variant, index) {
                  var checked = firstItemSize == variant.option1 ? "checked" : "";
                  if (noneMatch && index == 0) {
                    var checked = "checked";
                  }
                  var productId=data.id;
                  if(productId == "42306424078488"){
                var variantPreorder=window.ta.products[data.id].variants[variant.id];
                if (variantPreorder.quantity <= 0 ){
                 var templateId=window.ta.products[data.id].variants[variant.id].config.settingsTemplate;
                 var preorder=true;
                 var preorderKey=window.ta.settings[templateId].cart.labelText.key;
                 var preorderValue=window.ta.settings[templateId].cart.labelText.value;
                 
                }
                  else{
                    var preorder=false;
                  }
                  var preorderAttributes = preorder ? ` preorder="true" preorderKey="${preorderKey}" preorderValue="${preorderValue}"` : '';
                  var preorderLabelText = preorder ? '<br><span class="preorder-text">(preorder)</span>' : '';
                  }
                   var preorderAttributes = '';
                  var preorderLabelText = '';
                  upsellItem +=
                    '<div data-value="' +
                    variant.option1 +
                    '" class="Size_name_ofoption swatch-element" onclick="changeVariant(event)">' +
                    '<input class="optz" data-index="option1" type="radio" value="' +
                    variant.option1 +
                    '" ' +
                    checked +
                    ' data-variantid="' +
                    variant.id +
                    '"' + preorderAttributes +'>' +
                    '<label for="">' +
                    variant.option1 +
                    preorderLabelText +
                    "</label>" +
                    "</div>";
                });
    
                upsellItem +=
                  '<div class="sc-add-to-cart">' +
                  '<a href="#" onclick="addSuggestedItemToCartPair(event)" data-variantid="' +
                  matchingVariants[0].id +
                  '" class="sc-icon-plus"> <div class="innerbtn"> ADD PAIR  </div></a> <a href="#" onclick="addSuggestedItemToCart(event)" data-variantid="' +
                  matchingVariants[0].id +
                  '" class="sc-icon-plus"><div class="innerbtn">  ADD ONE </div></a>' + "</div>";
    
                upsellItem += "</div></div>";
              }
            });
    
            if (text) {
            const second_html = await fetchBeanieProductHtml(
              "Grey",
              text,
              fillColor,
              outlineColor,
              estimatedDelivery,
              colorMap[fillColor] || fillColor,
              colorMap[outlineColor] || outlineColor
            );
    
            if (second_html) {
              upsellItem += second_html;
            }
          }
        } catch (error) {
          console.error("Error getting product data:", error);
        }
      }
    return upsellItem;
    }
    


    //wristendmain
    
    async function updateUpsells(
      count,
      desiredColor,
      fillColor,
      outlineColor,
      text,
      estimatedDelivery,
      firstItemSize,
      suggestRemaining
    ) {
     console.log("sectionfirstone")
      var message = document.querySelectorAll(".sc-upsell-msg");
      var bar = document.querySelector(".progress-container");
      var progress = document.querySelectorAll(".progress-container .progress");
      var suggestions = document.querySelector(".side-cart .suggestions");
      let discountThreshold = document.querySelector('div.discount__price');
      var newFillColor, newOutlineColor;
    
      let upsellItem = "";
    
      bar.style.display = "block";
      message.forEach(function (ele) {
        ele.style.display = "block";
      });
    
    
      if (count == 0) {
        message.forEach(function (ele) {
          ele.innerHTML =
            // "Buy 2 get 20% off & free ship. Add more to save up to 50%.";
            "40% off 4 + FREE SHIPPING.  50% off 6 + FREE EXPRESS.";
          
          
    
        });
        bar.style.display = "block";
        message.style.display = "block";
        progress.forEach(function (ele) {
          ele.style.width = "0px";
        });
      } else if (count == 1) {
        message.forEach(function (ele) {
          ele.innerHTML = 
            // "Add <b>1</b> more item for <b>20% OFF & FREE SHIP</b>";
             "Add 1 more for 20% off, or 2 more 30% off.";
    
        });
        progress.forEach(function (ele) {
          ele.style.width = "15%";
    
          ele.style.background = "#fff";
        });
      } else if (count == 2) {
        message.forEach(function (ele) {
          ele.innerHTML =
            // "You unlocked 20% off & free ship! Add <b>1</b> item for 30% off!";
             "Add 1 more for 30% off.";
    
        });
        progress.forEach(function (ele) {
          ele.style.width = "30%";
    
          ele.style.background = "#01ffa8";
        });
      } else if (count == 3) {
        if (discountThreshold) {
        message.forEach(function (ele) {
          ele.innerHTML =
            "Add 1 more for 40% off & FREE SHIP!";
    
        });
          }
        else {
      message.forEach(function (ele) {
      ele.innerHTML = "Add 1 more for 40% off";
      });
      }
        progress.forEach(function (ele) {
          ele.style.width = "54%";
    
          ele.style.background =
            "linear-gradient(to right, #01ffa8 0%, #33ccff 70%)";
        });
      } else if (count == 4) {
        message.forEach(function (ele) {
          ele.innerHTML =
            
            // "You unlocked 40% off! Add <b>2</b> more items for 50% off!";
             "Add 2 more for 50% off & free express service!";
    
        });
        progress.forEach(function (ele) {
          ele.style.width = "80%";
    
          ele.style.background =
            "linear-gradient(to right, #01ffa8 0%, #33ccff 70%, #9417de 90%)";
        });
      } else if (count == 5) {
        message.forEach(function (ele) {
          ele.innerHTML = 
            "You're saving 40%. Just <b>1</b> more item for 50% off & free express service!";
        });
        progress.forEach(function (ele) {
          ele.style.width = "86%";
    
          ele.style.background =
            "linear-gradient(to right, #01ffa8 0%, #33ccff 60%, #9417de 80%)";
        });
      } else if (count >= 6) {
        message.forEach(function (ele) {
          ele.innerHTML = "Well played. You acheived our maximum discount!";
        });
        progress.forEach(function (ele) {
          ele.style.width = "100%";
          ele.style.background =
            "linear-gradient(to right, rgb(1, 255, 168) 0%, rgb(51, 204, 255) 29%,rgb(148, 23, 222) 79%, rgb(255, 40, 237) 89%)";
        });
      }
    
      if (suggestRemaining) {
        return;
      }
    
      if (fillColor == "Light Blue") {
        newFillColor = "Ice Blue";
      } else {
        newFillColor = fillColor;
      }
      if (outlineColor == "Light Blue") {
        newOutlineColor = "Ice Blue";
      } else {
        newOutlineColor = outlineColor;
      }
       
      if (desiredColor) {
     
        try {
          const response = await fetch("/products/custom-numbered-compression-arm-sleeve.js", {
            method: "GET",
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              Accept: "application/json",
            },
          });
    
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
    
          const data = await response.json();
    
            // Assuming the product object has a 'variants' array
         
            const variants = data.variants;
    
            let colors, colors2, color3, color4, colorsOptions;
    
            if (text) {
              colorsOptions = [
                "No Color",
                "White",
                "Black",
                "Red",
                "Orange",
                "Yellow",
                "Neon Green",
                "Light Blue",
                "Royal",
                "Navy",
                "Hot Pink",
              ];
              colors = [
                desiredColor,
                newFillColor,
               
              ];
              colors4=[desiredColor, newFillColor,]
              colors3=[newOutlineColor, "Black", desiredColor,]
              colors2 = ["Pink Sprinkles", desiredColor, "Blue Sprinkles"];
            } else {
              colors = [desiredColor, "White", "Black", "Ice Blue", "Red", "Royal"];
              colors2 = [];
            }
    
            colors.forEach((color, colorIndex) => {
             
              const matchingVariants = variants.filter(
                (variant) => variant.option2 === color && variant.available
              );
    
              if (text) {
                if (colorIndex === 0) {
                  dataFillColor = fillColor;
                  dataOutlineColor = outlineColor;
                }
                if (colorIndex === 1) {
                  dataFillColor = outlineColor;
                  if (!colorsOptions.includes(desiredColor)) {
                    dataOutlineColor = "Black";
                  } else {
                    dataOutlineColor = desiredColor;
                  }
                }
                if (colorIndex === 2) {
                  if (!colorsOptions.includes(desiredColor)) {
                    dataFillColor = "Black";
                  } else {
                    dataFillColor = desiredColor;
                  }
                  dataOutlineColor = fillColor;
                }
                if (colorIndex === 3) {
                  if (!colorsOptions.includes(desiredColor)) {
                    dataFillColor = "White";
                  } else {
                    dataFillColor = desiredColor;
                  }
                  dataOutlineColor = fillColor;
                }
                if (colorIndex === 4) {
                  dataFillColor = outlineColor;
                  dataOutlineColor = fillColor;
                }
              } else {
                dataFillColor = fillColor;
                dataOutlineColor = outlineColor;
              }
    
              var cssFillColor = dataFillColor;
              var cssOutlineColor = dataOutlineColor;
    
              const colorMap = {
                Royal: "rgb(0, 0, 204)",
                "Light Blue": "rgb(51, 204, 255)",
                "Neon Green": "rgb(2 249 54)",
                Navy: "rgb(0 5 116)",
                "Hot Pink": "rgb(246 33 87)",
                Orange: "rgb(255 64 0)",
              };
              if (colorMap[dataFillColor]) {
                cssFillColor = colorMap[cssFillColor];
              }
              if (colorMap[dataOutlineColor]) {
                cssOutlineColor = colorMap[cssOutlineColor];
              }
             
              if (matchingVariants.length > 0) {
                upsellItem +=
                  '<div class="suggest-item this" data-text="' +
                  text +
                  '" data-fill="' +
                  dataFillColor +
                  '" data-outline="' +
                  dataOutlineColor +
                  '" data-delivery="' +
                  estimatedDelivery +
                  '" data-index="' +
                  colorIndex +
                  '">' +
                  '<img class="product-img" src="' +
                  matchingVariants[0].featured_image.src +
                  '" alt="' +
                  matchingVariants[0].name +
                  '">';
                if (text) {
                  upsellItem +=
                    '<div class="item-text" style="display: block;"><div class="item-text-m" style="-webkit-text-stroke-color: ' +
                    cssOutlineColor +
                    "; color: " +
                    cssFillColor +
                    ';">' +
                    text +
                    "</div></div>";
                }
                upsellItem += '<div class="item-action forsize">';
    
                var noneMatch = matchingVariants.every(
                  (variant) => variant.option1 !== firstItemSize
                );
                
                matchingVariants.forEach(function (variant, index) {
                  var checked = firstItemSize == variant.option1 ? "checked" : "";
                  if (noneMatch && index == 0) {
                    var checked = "checked";
                  }

               
                var productId=data.id;
                  if(productId == "42306424078488"){
                var variantPreorder=window.ta.products[data.id].variants[variant.id];
                 
                  // console.log(window.ta.products[data.id].variants[variant.id])
                
                if (variantPreorder.quantity <= 0 ){
                   
                 var templateId=window.ta.products[data.id].variants[variant.id].config.settingsTemplate;
                 var preorder=true;
                  var preorderKey=window.ta.settings[templateId].cart.labelText.key;
                  var preorderValue=window.ta.settings[templateId].cart.labelText.value;
                 
                  
                  }
                  
                  
           
                  var preorderAttributes = preorder ? ` preorder="true" preorderKey="${preorderKey}" preorderValue="${preorderValue}"` : '';
                  var preorderLabelText = preorder ? '<br><span class="preorder-text">(preorder)</span>' : '';
                  }
                  else{
                      var preorderAttributes ='';
                  var preorderLabelText ='';
                  }
                  upsellItem +=
                    '<div data-value="' +
                    variant.option1 +
                    '" class="Size_name_ofoption swatch-element" onclick="changeVariant(event)">' +
                    '<input class="optz" data-index="option1" type="radio" value="' +
                    variant.option1 +
                    '" ' +
                    checked +
                    ' data-variantid="' +
                    variant.id +
                    '"' + preorderAttributes + '>' +
                    '<label for="">' +
                    variant.option1 +
                    preorderLabelText +
                    "</label>" +
                    "</div>";
                });
    
                upsellItem +=
                  '<div class="sc-add-to-cart">' +
                  '<a href="#" onclick="addSuggestedItemToCartPair(event)" data-variantid="' +
                  matchingVariants[0].id +
                  '" class="sc-icon-plus"> <div class="innerbtn"> ADD PAIR </div></a> <a href="#" onclick="addSuggestedItemToCart(event)" data-variantid="' +
                  matchingVariants[0].id +
                  '" class="sc-icon-plus"><div class="innerbtn"> ADD ONE </div></a>' + "</div>";
    
                upsellItem += "</div></div>";
              }
            });

            try {
          const response = await fetch("/products/custom-wristband.js", {
            method: "GET",
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              Accept: "application/json",
            },
          });
    
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
    
          const datas = await response.json();
    
            // Assuming the product object has a 'variants' array
         
            const variantsec = datas.variants;


           colors4.forEach((color, colorIndex) => {



               const matchingVariantssec = variantsec.filter(
                (variant) => variant.option2 === color && variant.available
              );
              if (text) {

               if (colorIndex === 0) {
                  dataFillColor = fillColor;
                  dataOutlineColor = outlineColor;
                }
                if (colorIndex === 1) {
                  dataFillColor = outlineColor;
                 
                  if (!colorsOptions.includes(desiredColor)) {
                    dataOutlineColor = "Black";
                  }
                  
                   else {
                    dataOutlineColor = desiredColor;
                  }
                  if (desiredColor == 'Ice Blue'){
                    dataOutlineColor = "Light Blue";
                   }
                }
              } else {
                dataFillColor = fillColor;
                dataOutlineColor = outlineColor;
              }

              var cssFillColor = dataFillColor;
              var cssOutlineColor = dataOutlineColor;
    
              const colorMap = {
                Royal: "rgb(0, 0, 204)",
                "Light Blue": "rgb(51, 204, 255)",
                "Neon Green": "rgb(2 249 54)",
                Navy: "rgb(0 5 116)",
                "Hot Pink": "rgb(246 33 87)",
                Orange: "rgb(255 64 0)",
              };
              if (colorMap[dataFillColor]) {
                cssFillColor = colorMap[cssFillColor];
              }
              if (colorMap[dataOutlineColor]) {
                cssOutlineColor = colorMap[cssOutlineColor];
              }
              if (matchingVariantssec.length > 0) {
                upsellItem +=
                  '<div class="suggest-item thirswrist  + ' + desiredColor  + ' " data-text="' +
                  text +
                  '" data-fill="' +
                  dataFillColor +
                  '" data-outline="' +
                  dataOutlineColor +
                  '" data-delivery="' +
                  estimatedDelivery +
                  '" data-index="' +
                  colorIndex +
                  '">' +
                  '<img class="product-img" src="' +
                  matchingVariantssec[0].featured_image.src +
                  '" alt="' +
                  matchingVariantssec[0].name +
                  '">';
                if (text) {
                  upsellItem +=
                    '<div class="item-text" style="display: block;"><div class="item-text-m" style="-webkit-text-stroke-color: ' +
                    cssOutlineColor +
                    "; color: " +
                    cssFillColor +
                    ';">' +
                    text +
                    "</div></div>";
                }
                upsellItem += '<div class="item-action forsize">';
    
                var noneMatch = matchingVariantssec.every(
                  (variant) => variant.option1 !== firstItemSize
                );
                
                matchingVariantssec.forEach(function (variant, index) {
                  var checked = firstItemSize == variant.option1 ? "checked" : "";
                  if (noneMatch && index == 0) {
                    var checked = "checked";
                  }

               
                var productId=datas.id;
                  if(productId == "42306424078488"){
                var variantPreorder=window.ta.products[datas.id].variants[variant.id];
                 
                  // console.log(window.ta.products[data.id].variants[variant.id])
                
                if (variantPreorder.quantity <= 0 ){
                   
                 var templateId=window.ta.products[data.id].variants[variant.id].config.settingsTemplate;
                 var preorder=true;
                  var preorderKey=window.ta.settings[templateId].cart.labelText.key;
                  var preorderValue=window.ta.settings[templateId].cart.labelText.value;
                 
                  
                  }
                  
                  
           
                  var preorderAttributes = preorder ? ` preorder="true" preorderKey="${preorderKey}" preorderValue="${preorderValue}"` : '';
                  var preorderLabelText = preorder ? '<br><span class="preorder-text">(preorder)</span>' : '';
                  }
                  else{
                      var preorderAttributes ='';
                  var preorderLabelText ='';
                  }
                  upsellItem +=
                    '<div data-value="' +
                    variant.option1 +
                    '" class="Size_name_ofoption swatch-element" onclick="changeVariant(event)">' +
                    '<input class="optz" data-index="option1" type="radio" value="' +
                    variant.option1 +
                    '" ' +
                    checked +
                    ' data-variantid="' +
                    variant.id +
                    '"' + preorderAttributes + '>' +
                    '<label for="">' +
                    variant.option1 +
                    preorderLabelText +
                    "</label>" +
                    "</div>";
                });
              
    
                upsellItem +=
                  '<div class="sc-add-to-cart">' +
                  '<a href="#" onclick="addSuggestedItemToCartPair(event)" data-variantid="' +
                  matchingVariantssec[0].id +
                  '" class="sc-icon-plus"> <div class="innerbtn"> ADD PAIR </div></a> <a href="#" onclick="addSuggestedItemToCart(event)" data-variantid="' +
                  matchingVariantssec[0].id +
                  '" class="sc-icon-plus"><div class="innerbtn"> ADD ONE </div></a>' + "</div>";
    
                upsellItem += "</div></div>";
              }



           })

           } catch (error) {
             console.error("Error fetching or processing product data:", error);
           }

           // ── JACKET render ──
           if (text) {
             const jacketHtml = await fetchJacketProductHtml(
               desiredColor,
               fillColor,
               outlineColor,
               text,
               estimatedDelivery,
               colorsOptions
             );
             if (jacketHtml) {
               upsellItem += jacketHtml;
             }
           }
           // ── END JACKET render ──

          
          colors3.forEach((color, colorIndex) => {
          const matchingVariants = variants.filter(
                (variant) => variant.option2 === color && variant.available
              );
            if (text) {
              if (colorIndex === 0) {
                 if (!colorsOptions.includes(desiredColor)) {
                    dataFillColor = "Black";
                  } else {
                    dataFillColor = desiredColor;
                  }
                  dataOutlineColor = fillColor;
                }
                if (colorIndex === 1) {
                 if (!colorsOptions.includes(desiredColor)) {
                    dataFillColor = "White";
                  } else {
                    dataFillColor = desiredColor;
                  }
                  dataOutlineColor = fillColor;
                }
                if (colorIndex === 2) {
                   dataFillColor = outlineColor;
                  dataOutlineColor = fillColor;
                }

            }
            else{
              dataFillColor = fillColor;
              dataOutlineColor = outlineColor;
            }

            var cssFillColor = dataFillColor;
              var cssOutlineColor = dataOutlineColor;
    
              const colorMap = {
                Royal: "rgb(0, 0, 204)",
                "Light Blue": "rgb(51, 204, 255)",
                "Neon Green": "rgb(2 249 54)",
                Navy: "rgb(0 5 116)",
                "Hot Pink": "rgb(246 33 87)",
                Orange: "rgb(255 64 0)",
              };
              if (colorMap[dataFillColor]) {
                cssFillColor = colorMap[cssFillColor];
              }
              if (colorMap[dataOutlineColor]) {
                cssOutlineColor = colorMap[cssOutlineColor];
              }

              if (matchingVariants.length > 0) {
                upsellItem +=
                  '<div class="suggest-item this" data-text="' +
                  text +
                  '" data-fill="' +
                  dataFillColor +
                  '" data-outline="' +
                  dataOutlineColor +
                  '" data-delivery="' +
                  estimatedDelivery +
                  '" data-index="' +
                  colorIndex +
                  '">' +
                  '<img class="product-img" src="' +
                  matchingVariants[0].featured_image.src +
                  '" alt="' +
                  matchingVariants[0].name +
                  '">';
                if (text) {
                  upsellItem +=
                    '<div class="item-text" style="display: block;"><div class="item-text-m" style="-webkit-text-stroke-color: ' +
                    cssOutlineColor +
                    "; color: " +
                    cssFillColor +
                    ';">' +
                    text +
                    "</div></div>";
                }
                upsellItem += '<div class="item-action forsize">';
    
                var noneMatch = matchingVariants.every(
                  (variant) => variant.option1 !== firstItemSize
                );
                
                matchingVariants.forEach(function (variant, index) {
                  var checked = firstItemSize == variant.option1 ? "checked" : "";
                  if (noneMatch && index == 0) {
                    var checked = "checked";
                  }

               
                var productId=data.id;
                  if(productId == "42306424078488"){
                var variantPreorder=window.ta.products[data.id].variants[variant.id];
                 
                  // console.log(window.ta.products[data.id].variants[variant.id])
                
                if (variantPreorder.quantity <= 0 ){
                   
                 var templateId=window.ta.products[data.id].variants[variant.id].config.settingsTemplate;
                 var preorder=true;
                  var preorderKey=window.ta.settings[templateId].cart.labelText.key;
                  var preorderValue=window.ta.settings[templateId].cart.labelText.value;
                 
                  
                  }
                  
                  
           
                  var preorderAttributes = preorder ? ` preorder="true" preorderKey="${preorderKey}" preorderValue="${preorderValue}"` : '';
                  var preorderLabelText = preorder ? '<br><span class="preorder-text">(preorder)</span>' : '';
                  }
                  else{
                      var preorderAttributes ='';
                  var preorderLabelText ='';
                  }
                  upsellItem +=
                    '<div data-value="' +
                    variant.option1 +
                    '" class="Size_name_ofoption swatch-element" onclick="changeVariant(event)">' +
                    '<input class="optz" data-index="option1" type="radio" value="' +
                    variant.option1 +
                    '" ' +
                    checked +
                    ' data-variantid="' +
                    variant.id +
                    '"' + preorderAttributes + '>' +
                    '<label for="">' +
                    variant.option1 +
                    preorderLabelText +
                    "</label>" +
                    "</div>";
                });
    
                upsellItem +=
                  '<div class="sc-add-to-cart">' +
                  '<a href="#" onclick="addSuggestedItemToCartPair(event)" data-variantid="' +
                  matchingVariants[0].id +
                  '" class="sc-icon-plus"> <div class="innerbtn"> ADD PAIR </div></a> <a href="#" onclick="addSuggestedItemToCart(event)" data-variantid="' +
                  matchingVariants[0].id +
                  '" class="sc-icon-plus"><div class="innerbtn"> ADD ONE </div></a>' + "</div>";
    
                upsellItem += "</div></div>";
              }

            


          })
    
            let upsellItemLast = "";
    
            var cssFillColorBeany = fillColor;
            var cssOutlineColorBeany = outlineColor;
    
            const colorMap = {
              Royal: "rgb(0, 0, 204)",
              "Light Blue": "rgb(51, 204, 255)",
              "Neon Green": "rgb(2 249 54)",
              Navy: "rgb(0 5 116)",
              "Hot Pink": "rgb(246 33 87)",
              Orange: "rgb(255 64 0)",
            };
            if (colorMap[fillColor]) {
              cssFillColorBeany = colorMap[cssFillColorBeany];
            }
            if (colorMap[outlineColor]) {
              cssOutlineColorBeany = colorMap[cssOutlineColorBeany];
            }
    
          if (text) {
            const html = await fetchBeanieProductHtml(
              "Black",
              text,
              fillColor,
              outlineColor,
              estimatedDelivery,
              colorMap[fillColor] || fillColor,
              colorMap[outlineColor] || outlineColor
            );
    
            if (html) {
              upsellItem += html;
            }
          }
    
            colors2.forEach((color, colorIndex) => {
              const matchingVariants = variants.filter(
                (variant) => variant.option2 === color && variant.available
              );
    
              if (text) {
                var newtext = text;
                if (colorIndex === 0) {
                  dataFillColor = 'White';
                  dataOutlineColor = 'Neon Green';
                }
                if (colorIndex === 1) {
                  dataFillColor = fillColor;
                  dataOutlineColor = outlineColor;
                  newtext = "†";
                }
                if (colorIndex === 2) {
                  dataFillColor = 'White';
                  dataOutlineColor = 'Hot Pink';
                }
              } else {
                dataFillColor = fillColor;
                dataOutlineColor = outlineColor;
              }
    
              var cssFillColor = dataFillColor;
              var cssOutlineColor = dataOutlineColor;
    
              const colorMap = {
                Royal: "rgb(0, 0, 204)",
                "Light Blue": "rgb(51, 204, 255)",
                "Neon Green": "rgb(2 249 54)",
                Navy: "rgb(0 5 116)",
                "Hot Pink": "rgb(246 33 87)",
                Orange: "rgb(255 64 0)",
              };
              if (colorMap[dataFillColor]) {
                cssFillColor = colorMap[cssFillColor];
              }
              if (colorMap[dataOutlineColor]) {
                cssOutlineColor = colorMap[cssOutlineColor];
              }
    
              if (matchingVariants.length > 0) {
                upsellItem +=
                  '<div class="suggest-item thistwo" data-text="' +
                  newtext +
                  '" data-fill="' +
                  dataFillColor +
                  '" data-outline="' +
                  dataOutlineColor +
                  '" data-delivery="' +
                  estimatedDelivery +
                  '" data-index="' +
                  colorIndex +
                  '">' +
                  '<img class="product-img" src="' +
                  matchingVariants[0].featured_image.src +
                  '" alt="' +
                  matchingVariants[0].name +
                  '">';
                if (newtext) {
                  upsellItem +=
                    '<div class="item-text" style="display: block;"><div class="item-text-m" style="-webkit-text-stroke-color: ' +
                    cssOutlineColor +
                    "; color: " +
                    cssFillColor +
                    ';">' +
                    newtext +
                    "</div></div>";
                }
                upsellItem += '<div class="item-action forsize">';
    
                var noneMatch = matchingVariants.every(
                  (variant) => variant.option1 !== firstItemSize
                );
    
                matchingVariants.forEach(function (variant, index) {
                  var checked = firstItemSize == variant.option1 ? "checked" : "";
                  if (noneMatch && index == 0) {
                    var checked = "checked";
                  }
                  var productId=data.id;
                  if(productId == "42306424078488"){
                var variantPreorder=window.ta.products[data.id].variants[variant.id];
                if (variantPreorder.quantity <= 0 ){
                 var templateId=window.ta.products[data.id].variants[variant.id].config.settingsTemplate;
                 var preorder=true;
                 var preorderKey=window.ta.settings[templateId].cart.labelText.key;
                 var preorderValue=window.ta.settings[templateId].cart.labelText.value;
                 
                }
                  else{
                    var preorder=false;
                  }
                  var preorderAttributes = preorder ? ` preorder="true" preorderKey="${preorderKey}" preorderValue="${preorderValue}"` : '';
                  var preorderLabelText = preorder ? '<br><span class="preorder-text">(preorder)</span>' : '';
                  }
                   var preorderAttributes = '';
                  var preorderLabelText = '';
                  upsellItem +=
                    '<div data-value="' +
                    variant.option1 +
                    '" class="Size_name_ofoption swatch-element" onclick="changeVariant(event)">' +
                    '<input class="optz" data-index="option1" type="radio" value="' +
                    variant.option1 +
                    '" ' +
                    checked +
                    ' data-variantid="' +
                    variant.id +
                    '"' + preorderAttributes +'>' +
                    '<label for="">' +
                    variant.option1 +
                    preorderLabelText +
                    "</label>" +
                    "</div>";
                });
    
                upsellItem +=
                  '<div class="sc-add-to-cart">' +
                  '<a href="#" onclick="addSuggestedItemToCartPair(event)" data-variantid="' +
                  matchingVariants[0].id +
                  '" class="sc-icon-plus"> <div class="innerbtn"> ADD PAIR  </div></a> <a href="#" onclick="addSuggestedItemToCart(event)" data-variantid="' +
                  matchingVariants[0].id +
                  '" class="sc-icon-plus"><div class="innerbtn">  ADD ONE </div></a>' + "</div>";
    
                upsellItem += "</div></div>";
              }
            });
    
            if (text) {
            const second_html = await fetchBeanieProductHtml(
              "Grey",
              text,
              fillColor,
              outlineColor,
              estimatedDelivery,
              colorMap[fillColor] || fillColor,
              colorMap[outlineColor] || outlineColor
            );
    
            if (second_html) {
              upsellItem += second_html;
            }
          }
        } catch (error) {
          console.error("Error getting product data:", error);
        }
      }
    return upsellItem;
    }
    
    async function fetchBeanieProductHtml(filterOption2, text, fillColor, outlineColor, estimatedDelivery, cssOutlineColorBeany, cssFillColorBeany) {
    
      let upsellItemLast = "";
    
      try {
        const response = await fetch("/products/custom-numbered-beanie.js", {
          method: "GET",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/json",
          },
        });
    
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
    
        const data = await response.json();
    
          if (data.variants.length > 0) {
            const beanyVariants = data.variants.filter(
              (variant) => variant.option2 === filterOption2
            );
    
            if (beanyVariants.length > 0) {
    
              upsellItemLast +=
                '<div class="suggest-item twosingle" data-text="' +
                text +
                '" data-fill="' +
                fillColor +
                '" data-outline="' +
                outlineColor +
                '" data-delivery="' +
                estimatedDelivery +
                '" data-index="5">';
              upsellItemLast +=
                '<img class="product-img" src="' +
                beanyVariants[0].featured_image.src +
                '" alt="' +
                beanyVariants[0].name +
                '">';
              upsellItemLast +=
                '<div class="item-text" style="display: block;"><div class="item-text-m" style="-webkit-text-stroke-color: ' +
                cssFillColorBeany +
                "; color: " +
                cssOutlineColorBeany +
                ';">' +
                text +
                "</div></div>";
              upsellItemLast += '<div class="item-action forsize">';
    
              let firstAvailableChecked = false;
              let variantId = "";
    
              beanyVariants.forEach(function (variant) {
                if (variant.available) {
                  const checked = !firstAvailableChecked ? "checked" : "";
                  if (!firstAvailableChecked) {
                    firstAvailableChecked = true;
                    variantId = variant.id;
                  }
    
                  upsellItemLast +=
                    '<div data-value="' +
                    variant.option1 +
                    '" class="Size_name_ofoption swatch-element" onclick="changeVariant(event)">' +
                    '<input class="optz ' +
                    variant.available +
                    '" type="radio" value="' +
                    variant.option1 +
                    '" ' +
                    checked +
                    ' data-variantid="' +
                    variant.id +
                    '">' +
                    '<label for="">' +
                    variant.option1 +
                    "</label>" +
                    "</div>";
                }
              });
    
              upsellItemLast +=
             
               '<div class="sc-add-to-cart">' +
                  '<a href="#" onclick="addSuggestedItemToCartPair(event)" data-variantid="' +
                 variantId +
                  '" class="sc-icon-plus"> <div class="innerbtn"> ADD PAIR </div></a> <a href="#" onclick="addSuggestedItemToCart(event)" data-variantid="' +
                  variantId +
                  '" class="sc-icon-plus"><div class="innerbtn"> ADD ONE </div></a>' + "</div>";
    
                upsellItemLast += "</div></div>";
              
    
              // return upsellItemLast;
            }
          }
    
          return upsellItemLast;
          } catch (error) {
            console.error("Error getting product data:", error);
            return ""; // Return empty string in case of an error
          }
    }

    // ── JACKET SUGGESTIONS ──
    // Renders up to 2 Varsity Jacket suggestions.
    //
    // Skip ENTIRELY if the cart's trigger product is itself a jacket — no point
    // suggesting a jacket when they just added one.
    //
    // Slot 0 (Jacket #1):
    //   Body color:    desiredColor (cart item's body color)
    //                  → fallback to Black if desiredColor isn't a jacket color
    //   Number fill:   fillColor (unchanged from cart item)
    //   Number outline: outlineColor (unchanged from cart item)
    //
    // Slot 1 (Jacket #2):
    //   Body color:    outlineColor (Light Blue → Ice Blue swap)
    //                  → fallback to Black if not a jacket color
    //   Number fill:   outlineColor (swap — source's outline becomes fill)
    //   Number outline: fillColor   (swap — source's fill becomes outline)
    //
    // OOS sizes are auto-excluded by Shopify variant.available.
    async function fetchJacketProductHtml(desiredColor, fillColor, outlineColor, text, estimatedDelivery, colorsOptions) {
      var jacketHtml = "";
      var sourceIsJacket = (_lastTriggerProductId == 9098257203352);

      try {
        const response = await fetch("/products/custom-numbered-varsity-jacket.js", {
          method: "GET",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/json",
          },
        });
        if (!response.ok) throw new Error("Network response was not ok");
        const dataJ = await response.json();
        const variantsJ = dataJ.variants;

        const colorMap = {
          Royal: "rgb(0, 0, 204)",
          "Light Blue": "rgb(51, 204, 255)",
          "Neon Green": "rgb(2 249 54)",
          Navy: "rgb(0 5 116)",
          "Hot Pink": "rgb(246 33 87)",
          Orange: "rgb(255 64 0)",
        };

        // Helper: does the jacket have any in-stock variant in this body color?
        var hasBodyColor = function(c) {
          return variantsJ.some(function(v) { return v.option2 === c && v.available; });
        };

        // Resolve body colors with Black fallback
        var body0 = hasBodyColor(desiredColor) ? desiredColor : "Black";

        var newOutlineColor = outlineColor === "Light Blue" ? "Ice Blue" : outlineColor;
        var body1 = hasBodyColor(newOutlineColor) ? newOutlineColor : "Black";

        // Slot definitions: body color + number fill/outline per slot
        var slots = [
          { body: body0, numFill: fillColor,    numOutline: outlineColor },
          { body: body1, numFill: outlineColor, numOutline: fillColor    }
        ];

        slots.forEach(function(slot, colorIndex) {
          // Slot 0 is skipped if source product is itself a jacket — it would
          // duplicate the jacket the customer just added. Slot 1 still renders.
          if (colorIndex === 0 && sourceIsJacket) return;

          const matchingVariantsJ = variantsJ.filter(
            (variant) => variant.option2 === slot.body && variant.available
          );
          if (matchingVariantsJ.length === 0) return; // safety — shouldn't fire if Black is in stock

          var dataFillColor = text ? slot.numFill : fillColor;
          var dataOutlineColor = text ? slot.numOutline : outlineColor;

          var cssFillColor = colorMap[dataFillColor] || dataFillColor;
          var cssOutlineColor = colorMap[dataOutlineColor] || dataOutlineColor;

          jacketHtml +=
            '<div class="suggest-item jacket" data-text="' + text +
            '" data-fill="' + dataFillColor +
            '" data-outline="' + dataOutlineColor +
            '" data-delivery="' + estimatedDelivery +
            '" data-index="' + colorIndex + '">' +
            '<img class="product-img" src="' + matchingVariantsJ[0].featured_image.src +
            '" alt="' + matchingVariantsJ[0].name + '">' +
            '<span class="jacket-new-badge" data-jacket-trigger="1" role="button" tabindex="0" aria-label="More info about this jacket"><span class="badge-line-1"><span class="badge-info-icon">i</span><span class="badge-new">NEW</span></span>w/ Chenille\nPatches!</span>';
          if (text) {
            jacketHtml +=
              '<div class="item-text" style="display: block;"><div class="item-text-m" style="-webkit-text-stroke-color: ' +
              cssOutlineColor + '; color: ' + cssFillColor + ';">' +
              text + '</div></div>';
          }
          jacketHtml += '<div class="item-action forsize">';

          matchingVariantsJ.forEach(function (variant, idx) {
            var checked = idx === 0 ? "checked" : "";
            jacketHtml +=
              '<div data-value="' + variant.option1 +
              '" class="Size_name_ofoption swatch-element" onclick="changeVariant(event)">' +
              '<input class="optz" data-index="option1" type="radio" value="' + variant.option1 +
              '" ' + checked + ' data-variantid="' + variant.id + '">' +
              '<label for="">' + variant.option1 + '</label>' +
              '</div>';
          });

          // Close item-action.forsize so the button is a sibling, not a child.
          jacketHtml += '</div>';

          // Jacket gets ONLY the Add to Cart button (no ADD PAIR)
          jacketHtml +=
            '<div class="sc-add-to-cart jacket-only">' +
            '<a href="#" onclick="addSuggestedItemToCart(event)" data-variantid="' +
            matchingVariantsJ[0].id +
            '" class="sc-icon-plus"><div class="innerbtn"> ADD TO CART </div></a>' +
            '</div>';

          // Detail popup — overlays ONLY the .product-img area (180px tall),
          // so size pills and ADD TO CART below remain visible and tappable.
          // TODO(mike): swap closeup background-image URL when provided.
          jacketHtml +=
            '<div class="jacket-detail-popup" aria-hidden="true">' +
              '<button type="button" class="jacket-detail-popup-close" aria-label="Close">×</button>' +
              '<div class="jacket-detail-popup-imgs">' +
                '<div class="jacket-detail-popup-img crop-bl"></div>' +
                '<div class="jacket-detail-popup-img closeup" style="background-image: url(\'https://cdn.shopify.com/s/files/1/0472/7278/8120/files/varsity_jacket_suggested_closeup.jpg?v=1777915567\');"></div>' +
              '</div>' +
              '<ul class="jacket-detail-popup-bullets">' +
                '<li>Premium, made-to-order 3-D chenille patches</li>' +
                '<li>Heavyweight hoodie material</li>' +
                '<li>Knitted collar, press buttons, welt pockets</li>' +
              '</ul>' +
            '</div>';
          jacketHtml += '</div>';
        });

        return jacketHtml;
      } catch (error) {
        console.error("Error fetching jacket product data:", error);
        return "";
      }
    }
    // ── END JACKET SUGGESTIONS ──
    
    function changeVariant(event) {
      var itemAction = event.target.closest(".item-action");
      var addToCart = itemAction.querySelector(".sc-add-to-cart a");
      var inputs = itemAction.querySelectorAll("input");
      var currentOption = event.currentTarget.querySelector("input");
      inputs.forEach(function (input) {
        input.removeAttribute("checked");
      });
    
      currentOption.setAttribute("checked", "");
      var selectedVariantId = currentOption.getAttribute("data-variantid");
      addToCart.setAttribute("data-variantid", selectedVariantId);
    }
    
    function addSuggestedItemToCart(event) {
      var sideCart = document.querySelector(".side-cart .side-cart-inner");
      var ajaxLoader = document.querySelector(".side-cart .sc-loading");
      var suggestRemaining;
    
      ajaxLoader.style.display = "block";
      sideCart.style.opacity = 0.5;
      var currentTarget = event.currentTarget;
      var currentParentN = currentTarget.parentNode;
    
      var moreprevious = currentParentN.parentNode;
      
      var currentvariant = moreprevious.querySelector(".optz[checked]");
      var currenVarid = currentvariant.getAttribute("data-variantid");
      var preorderVariant=currentvariant.getAttribute("preorder");
      if (preorderVariant){
        var preOrderKey=currentvariant.getAttribute("preorderkey");
        var preOrderValue=currentvariant.getAttribute("preordervalue");
        
      }
    
      currentTarget.setAttribute("data-variantid", currenVarid);
      var variantId = event.currentTarget.getAttribute("data-variantid");
      var itemAction = event.target.closest(".item-action");
      var itemSuggest = event.target.closest(".suggest-item");
      var itemsSuggested = document.querySelectorAll(".suggestions .suggest-item");
    
      if (itemsSuggested.length > 1) {
        suggestRemaining = itemsSuggested.length;
      } else {
        suggestRemaining = null;
      }
    
      var fill = itemSuggest.getAttribute("data-fill");
      var outline = itemSuggest.getAttribute("data-outline");
      var delivery = itemSuggest.getAttribute("data-delivery");
      var text = itemSuggest.getAttribute("data-text");
    
      var formData = new FormData();
      formData.append("id", variantId);
      formData.append("quantity", 1);
      if (text) {
      formData.append("properties[Embroidery Number]", text);
      }
      formData.append("properties[Fill Color]", fill);
      formData.append("properties[Outline Color]", outline);
      formData.append("properties[Estimated Delivery]", delivery);
      if (preorderVariant){
      
        formData.append(`properties[${preOrderKey}]`,preOrderValue )
      }
      
      fetch("/cart/add.js", {
        method: "POST",
        body: formData,
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/json",
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          updateCartDrawer(suggestRemaining);
          if (suggestRemaining) {
            itemSuggest.remove();
          }
          sideCart.classList.add("open");
          var bodyClass = document.body.className;
          if (bodyClass.indexOf("body-no-scroll") === -1) {
            document.body.className += " body-no-scroll";
          }
        })
        .catch((error) => {
        console.error("Error adding product to cart:", error);
        });
        }

   function addSuggestedItemToCartPair(event) {
      var sideCart = document.querySelector(".side-cart .side-cart-inner");
      var ajaxLoader = document.querySelector(".side-cart .sc-loading");
      var suggestRemaining;
    
      ajaxLoader.style.display = "block";
      sideCart.style.opacity = 0.5;
      var currentTarget = event.currentTarget;
      var currentParentN = currentTarget.parentNode;
    
      var moreprevious = currentParentN.parentNode;
      
      var currentvariant = moreprevious.querySelector(".optz[checked]");
      var currenVarid = currentvariant.getAttribute("data-variantid");
      var preorderVariant=currentvariant.getAttribute("preorder");
      if (preorderVariant){
        var preOrderKey=currentvariant.getAttribute("preorderkey");
        var preOrderValue=currentvariant.getAttribute("preordervalue");
        
      }
    
      currentTarget.setAttribute("data-variantid", currenVarid);
      var variantId = event.currentTarget.getAttribute("data-variantid");
      var itemAction = event.target.closest(".item-action");
      var itemSuggest = event.target.closest(".suggest-item");
      var itemsSuggested = document.querySelectorAll(".suggestions .suggest-item");
    
      if (itemsSuggested.length > 1) {
        suggestRemaining = itemsSuggested.length;
      } else {
        suggestRemaining = null;
      }
    
      var fill = itemSuggest.getAttribute("data-fill");
      var outline = itemSuggest.getAttribute("data-outline");
      var delivery = itemSuggest.getAttribute("data-delivery");
      var text = itemSuggest.getAttribute("data-text");
    
      var formData = new FormData();
      formData.append("id", variantId);
      formData.append("quantity", 2);
      if (text) {
      formData.append("properties[Embroidery Number]", text);
      }
      formData.append("properties[Fill Color]", fill);
      formData.append("properties[Outline Color]", outline);
      formData.append("properties[Estimated Delivery]", delivery);
      if (preorderVariant){
      
        formData.append(`properties[${preOrderKey}]`,preOrderValue )
      }
      
      fetch("/cart/add.js", {
        method: "POST",
        body: formData,
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/json",
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          updateCartDrawer(suggestRemaining);
          if (suggestRemaining) {
            itemSuggest.remove();
          }
          sideCart.classList.add("open");
          var bodyClass = document.body.className;
          if (bodyClass.indexOf("body-no-scroll") === -1) {
            document.body.className += " body-no-scroll";
          }
        })
        .catch((error) => {
          console.error("Error adding product to cart:", error);
        });
    }

// ── FLAG REMAP: swap flag emoji → text in cart properties before checkout ──────
// Detection: any line item where 'Embroidery Number' is a flag emoji (Regional
// Indicator pair). We swap it to a plain text label so ShipStation and the
// embroidery team can read it.
var FLAG_TEXT_TO_EMOJI = {
  'US Flag': '🇺🇸',
  'Venezuela Flag': '🇻🇪',
  'Japan Flag': '🇯🇵',
  'Dominican Flag': '🇩🇴',
  'Puerto Rico Flag': '🇵🇷',
  'Canada Flag': '🇨🇦',
  'Mexico Flag': '🇲🇽',
  'Korea Flag': '🇰🇷',
  'Prayer Hands': '🙏',
  'Victory Hand': '✌️',
  'Skull': '☠️',
  'Fire': '🔥',
  'Sunglasses': '😎',
  'Red Heart': '❤️',
  'Money Wings': '💸',
  'Pink Heart': '🩷',
  'Yellow Heart': '💛',
  'Green Heart': '💚',
  'Light Blue Heart': '🩵',
  'Purple Heart': '💜',
  'Black Heart': '🖤',
  'White Heart': '🤍'
};

var FLAG_EMOJI_TO_TEXT = {
  '🇺🇸': 'US Flag',
  '🇻🇪': 'Venezuela Flag',
  '🇯🇵': 'Japan Flag',
  '🇩🇴': 'Dominican Flag',
  '🇵🇷': 'Puerto Rico Flag',
  '🇨🇦': 'Canada Flag',
  '🇲🇽': 'Mexico Flag',
  '🇰🇷': 'Korea Flag',
  '🙏': 'Prayer Hands',
  '✌️': 'Victory Hand',
  '☠️': 'Skull',
  '🔥': 'Fire',
  '😎': 'Sunglasses',
  '❤️': 'Red Heart',
  '💸': 'Money Wings',
  '🩷': 'Pink Heart',
  '💛': 'Yellow Heart',
  '💚': 'Green Heart',
  '🩵': 'Light Blue Heart',
  '💜': 'Purple Heart',
  '🖤': 'Black Heart',
  '🤍': 'White Heart'
};

function remapFlagsBeforeCheckout() {
  return fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var remapPromises = [];
      cart.items.forEach(function(item) {
        // Remap any emoji Embroidery Number to a readable text label for ShipStation
        var embNum = item.properties['Embroidery Number'] || '';
        var mapped = FLAG_EMOJI_TO_TEXT[embNum];
        if (mapped) {
          // Preserve ALL existing properties, only swap Embroidery Number
          var newProps = Object.assign({}, item.properties);
          newProps['Embroidery Number'] = mapped;
          remapPromises.push(
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: newProps })
            }).then(function(r) { return r.json(); })
          );
        }
      });
      return Promise.all(remapPromises);
    })
    .catch(function(err) {
      // Log but don't block checkout if remap fails
      console.error('Flag remap error:', err);
    });
}
// ── END FLAG REMAP ────────────────────────────────────────────────────────────

// ── FLAG EMOJI FIX ────────────────────────────────────────────────────────────
// Windows doesn't render flag emoji natively. Adds noto-color-emoji-regular
// class to .item-text-m elements that contain Regional Indicator flag pairs.
// To roll back: delete from this comment to END FLAG EMOJI FIX.
(function() {
  function _fixFlagEmoji(root) {
    root.querySelectorAll('.item-text-m').forEach(function(el) {
      var text = el.textContent;
      if (FLAG_EMOJI_TO_TEXT[text] || /[\uD83C-\uDBFF][\uDC00-\uDFFF]|[\u2600-\u27FF]/u.test(text)) {
        el.classList.add('noto-color-emoji-regular');
      }
    });
  }

  function _observeFlagTargets() {
    var targets = [
      document.querySelector('.side-cart .sc-items'),
      document.querySelector('.side-cart .suggestions')
    ];
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) { _fixFlagEmoji(m.target); });
    });
    targets.forEach(function(t) {
      if (t) observer.observe(t, { childList: true, subtree: false });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', _observeFlagTargets);
  } else {
    _observeFlagTargets();
  }
})();
// ── END FLAG EMOJI FIX ───────────────────────────────────────────────────────
    